(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[6],{

/***/ "+Qka":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("fmRc"),
    assignMergeValue = __webpack_require__("t2Dn"),
    baseFor = __webpack_require__("cq/+"),
    baseMergeDeep = __webpack_require__("T1AV"),
    isObject = __webpack_require__("GoyQ"),
    keysIn = __webpack_require__("mTTR"),
    safeGet = __webpack_require__("itsj");

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),

/***/ "/uI8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: PILL_THEME

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/constants/ui.js
var ui = __webpack_require__("IWZK");

// EXTERNAL MODULE: ./node_modules/lodash/upperFirst.js
var upperFirst = __webpack_require__("gQMU");
var upperFirst_default = /*#__PURE__*/__webpack_require__.n(upperFirst);

// EXTERNAL MODULE: ./src/utils/debug.js
var debug = __webpack_require__("Djx3");

// CONCATENATED MODULE: ./src/utils/action.js


var action_reduceModelActions = function reduceModelActions(props) {
  var keys = props.keys,
      action = props.action,
      resource = props.resource,
      data = props.data,
      actionsMap = props.actionsMap;
  var actions = [];
  keys.forEach(function (modelKey) {
    /**
     * Example values for assoc action key construction
     * 1. action - set
     * 2. resource - user
     * 3. modelKey - merchantAccounts
     */

    /**
     * Process model
     */
    var models = data[modelKey];
    var actionKey = "".concat(action).concat(upperFirst_default()(modelKey));
    Object(debug["a" /* devLogger */])("models ".concat(actionKey), models);
    var modelAction = actionsMap[actionKey];

    if (!modelAction) {
      throw new Error("No action registered for ".concat(actionKey));
    }

    if (models && modelAction) {
      actions.push(modelAction(models));
    }
    /**
     * Process associations
     */


    var assocModelKey = "".concat(resource).concat(upperFirst_default()(modelKey));
    var assocModels = data[assocModelKey];
    var assocActionKey = "".concat(action).concat(upperFirst_default()(resource)).concat(upperFirst_default()(modelKey));
    var assocAction = actionsMap[assocActionKey];

    if (!assocAction) {
      throw new Error("No assoc action registered for ".concat(assocActionKey));
    }

    if (assocModels && assocAction) {
      Object(debug["a" /* devLogger */])("assocModels ".concat(assocActionKey), assocModels);
      actions.push(assocAction(assocModels));
    }
  });
  return actions;
};
var NO_OP = function NO_OP() {};
// CONCATENATED MODULE: ./src/components/Pill/index.jsx


var _PILL_STATUS_CLASSES;

var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var DEFAULT_CLASSES = {
  container: "flex w-100 items-end justify-end mv2",
  copy: "f7 pa2 br2 fw5 flex-shrink-0 items-center"
};
var PILL_STATUS_CLASSES = (_PILL_STATUS_CLASSES = {}, Object(defineProperty["a" /* default */])(_PILL_STATUS_CLASSES, ui["n" /* STATUS */].DEFAULT, "bg-black-05 color-primary"), Object(defineProperty["a" /* default */])(_PILL_STATUS_CLASSES, ui["n" /* STATUS */].WARNING, "bg-warning-05"), Object(defineProperty["a" /* default */])(_PILL_STATUS_CLASSES, ui["n" /* STATUS */].DANGER, "bg-danger-05"), Object(defineProperty["a" /* default */])(_PILL_STATUS_CLASSES, ui["n" /* STATUS */].SUCCESS, "bg-success-05"), Object(defineProperty["a" /* default */])(_PILL_STATUS_CLASSES, ui["n" /* STATUS */].NEUTRAL, "bg-white bg-white--hover ba color-primary"), _PILL_STATUS_CLASSES);
var PILL_THEME = {
  SLIM: "slim",
  DEFAULT: "default"
};

var Pill_Pill = function Pill(_ref) {
  var copy = _ref.copy,
      customClasses = _ref.customClasses,
      theme = _ref.theme,
      children = _ref.children,
      status = _ref.status,
      onClick = _ref.onClick;
  var THEME_CLASSES = theme === PILL_THEME.SLIM ? ui["m" /* SLIM_PILL_CLASSES */] : DEFAULT_CLASSES;

  var classes = _objectSpread(_objectSpread({}, THEME_CLASSES), customClasses);

  var statusClasses = status && PILL_STATUS_CLASSES[status] ? PILL_STATUS_CLASSES[status] : PILL_STATUS_CLASSES[ui["n" /* STATUS */].DEFAULT];
  return __jsx("div", {
    className: classes.container,
    onClick: onClick || NO_OP
  }, __jsx("div", {
    className: "".concat(classes.copy, " ").concat(statusClasses)
  }, copy, children));
};

Pill_Pill.defaultProps = {
  theme: PILL_THEME.DEFAULT
};
/* harmony default export */ var components_Pill = __webpack_exports__["a"] = (Pill_Pill);

/***/ }),

/***/ "1OyB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _classCallCheck; });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ "3L66":
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__("MMmD"),
    isObjectLike = __webpack_require__("ExA7");

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ "3OWR":
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__("MrPd"),
    copyObject = __webpack_require__("juv8"),
    createAssigner = __webpack_require__("LsHQ"),
    isArrayLike = __webpack_require__("MMmD"),
    isPrototype = __webpack_require__("6sVZ"),
    keys = __webpack_require__("7GkX");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),

/***/ "5vWv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("wx14");

// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__("MX0m");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__("YFqc");
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/utils/constants/ui.js
var ui = __webpack_require__("IWZK");

// EXTERNAL MODULE: ./node_modules/lodash/compact.js
var compact = __webpack_require__("wig9");
var compact_default = /*#__PURE__*/__webpack_require__.n(compact);

// EXTERNAL MODULE: ./src/components/Pill/index.jsx + 1 modules
var Pill = __webpack_require__("/uI8");

// EXTERNAL MODULE: ./src/components/LoadingSpinner/index.jsx + 1 modules
var LoadingSpinner = __webpack_require__("a/D+");

// CONCATENATED MODULE: ./src/components/Nav/NavLinkContent.jsx
var __jsx = react_default.a.createElement;





var NavLinkContent_NavLinkContent = function NavLinkContent(_ref, ref) {
  var onClick = _ref.onClick,
      loading = _ref.loading,
      isFirst = _ref.isFirst,
      icon = _ref.icon,
      scheme = _ref.scheme,
      nodeTitle = _ref.nodeTitle,
      callout = _ref.callout,
      descriptions = _ref.descriptions;
  return __jsx("div", {
    ref: ref,
    onClick: onClick,
    className: "link db w-100 fl black-80"
  }, __jsx("li", {
    className: classnames_default()("menu__subNav--listItem ph3 pv3 flex flex-row pointer w-100 bb b--black-05 bn-l bg-white--hover", {
      pt3: !isFirst
    })
  }, icon && __jsx("div", {
    className: "div",
    style: {
      height: 40,
      width: 40
    }
  }, icon({
    scheme: scheme
  })), __jsx("div", {
    className: "flex flex-column w-100 pl3"
  }, __jsx("div", {
    className: "flex flex-row justify-start"
  }, __jsx("div", {
    className: "f5 fw6 color-text--primary"
  }, nodeTitle), loading ? __jsx("div", {
    className: "pl1"
  }, __jsx(LoadingSpinner["a" /* default */], {
    customClasses: {
      ring: "blue",
      size: "small"
    }
  })) : null, callout && __jsx(Pill["a" /* default */], {
    copy: callout,
    customClasses: {
      container: "pl2",
      copy: "f7 pa1 br2 fw5 flex-shrink-0 ph2 fw6"
    }
  })), __jsx("div", {
    className: "pt2"
  }, descriptions.length > 0 && descriptions.map(function (desc, descIx) {
    return __jsx("div", {
      key: descIx,
      className: classnames_default()("f6 lh-copy", {
        pt1: descIx > 0
      })
    }, desc);
  })))));
};

/* harmony default export */ var Nav_NavLinkContent = (/*#__PURE__*/react_default.a.forwardRef(NavLinkContent_NavLinkContent));
// EXTERNAL MODULE: ./src/utils/analytics.js + 15 modules
var analytics = __webpack_require__("svBA");

// EXTERNAL MODULE: ./src/utils/context/index.js
var context = __webpack_require__("jMmE");

// CONCATENATED MODULE: ./src/utils/context/nav.js
var nav_jsx = react_default.a.createElement;



var _createUseContext = Object(context["b" /* createUseContext */])(function (Provider) {
  return function (_ref) {
    var children = _ref.children;

    var _useState = Object(react["useState"])({
      open: false,
      activeSection: null
    }),
        values = _useState[0],
        setValues = _useState[1];

    var handleMouseLeave = function handleMouseLeave() {
      setValues({
        open: false,
        activeSection: null
      });
    };
    /**
     * Close the nav when user moves the cursor off screen
     */


    Object(react["useEffect"])(function () {
      if (typeof document !== "undefined") {
        document.body.addEventListener("mouseleave", handleMouseLeave);
      }

      return function () {
        if (typeof document !== "undefined") {
          document.body.addEventListener("mouseleave", handleMouseLeave);
        }
      };
    }, []);
    return nav_jsx(Provider, {
      value: {
        values: values,
        setValues: setValues
      }
    }, children);
  };
}),
    NavContext = _createUseContext.Context,
    NavContextProvider = _createUseContext.ContextProvider,
    useNavContext = _createUseContext.useContext;


// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("Ff2n");

// EXTERNAL MODULE: ./node_modules/lodash/startCase.js
var startCase = __webpack_require__("50DI");
var startCase_default = /*#__PURE__*/__webpack_require__.n(startCase);

// EXTERNAL MODULE: ./src/utils/env.js
var env = __webpack_require__("5JAB");

// CONCATENATED MODULE: ./src/utils/nav.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



var nav_flattenConfigRoutes = function flattenConfigRoutes(config, parent) {
  return Object.keys(config).reduce(function (memo, key) {
    if (typeof config[key] === "object") {
      if (config[key].as) {
        var result = {
          label: startCase_default()(key),
          as: config[key].as,
          path: config[key]
        };

        if (parent) {
          result.parent = startCase_default()(parent);
        }

        memo.push(result);
      } else {
        memo = memo.concat(flattenConfigRoutes(config[key], key));
      }
    }

    return memo;
  }, []);
};

var formatConfig = function formatConfig(config) {
  return _objectSpread({
    label: config.label,
    parent: config.parent
  }, config.path);
};

var getNextAndPreviousRoutes = function getNextAndPreviousRoutes(_ref) {
  var config = _ref.config,
      asPath = _ref.asPath;
  var flatRoutes = nav_flattenConfigRoutes(config);
  var targetIndex = flatRoutes.findIndex(function (_ref2) {
    var as = _ref2.as;
    return as === asPath;
  });
  var prev = flatRoutes[targetIndex - 1];
  var next = flatRoutes[targetIndex + 1];
  return {
    prev: prev ? formatConfig(prev) : null,
    next: next ? formatConfig(next) : null
  };
};
var nav_isZone = function isZone() {
  try {
    return Boolean(Object(env["a" /* getConfig */])("BASE_PATH"));
  } catch (error) {
    return false;
  }
};
var nav_isZoneMatch = function isZoneMatch(zone) {
  try {
    return Boolean(zone === Object(env["a" /* getConfig */])("BASE_PATH"));
  } catch (error) {
    return false;
  }
};
// EXTERNAL MODULE: ./src/utils/route.js
var utils_route = __webpack_require__("Fihp");

// CONCATENATED MODULE: ./src/components/ZoneLink/index.jsx


var ZoneLink_jsx = react_default.a.createElement;





/**
 * zone (currently in a zone app)
 * - destination-zone - local nav in zone - requires Link
 * - destination-otherZone-or-main - nav to external zone main - requires anchor tag to absolute path - no back rewrites
 * main (the main app)
 * - destination-zone - nav to external zone - requires anchor tag for rewrites
 * - destination-main - nav local - requires Link
 */

var ZoneLink_ZoneLink = function ZoneLink(_ref) {
  var zone = _ref.zone,
      href = _ref.href,
      children = _ref.children,
      routeProps = _ref.routeProps,
      linkProps = _ref.linkProps,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["zone", "href", "children", "routeProps", "linkProps"]);

  if (href) {
    var currentlyInZone = nav_isZone();

    if (currentlyInZone) {
      var zoneMatch = nav_isZoneMatch(zone);

      if (zoneMatch) {
        var strippedHref = href.replace(new RegExp(Object(env["a" /* getConfig */])("BASE_PATH")), "");
        return ZoneLink_jsx(link_default.a, Object(esm_extends["a" /* default */])({}, routeProps, {
          href: strippedHref
        }), ZoneLink_jsx("a", Object(esm_extends["a" /* default */])({
          id: "zone-destination-zone"
        }, linkProps, props), children));
      } else {
        // Need to go back to the main app - no rewrites on local
        var toMainApp = Object(utils_route["a" /* getMainAppPath */])(href);
        return ZoneLink_jsx("a", Object(esm_extends["a" /* default */])({
          id: "zone-destination-otherZone-or-main",
          href: toMainApp
        }, linkProps, props), children);
      }
    } else {
      /**
       * When the route destination is zone && not currently in a zone
       * - then anchor tag to zone
       */
      if (zone) {
        return ZoneLink_jsx("a", Object(esm_extends["a" /* default */])({
          id: "main-destination-zone",
          href: href
        }, linkProps, props), children);
      } else {
        return ZoneLink_jsx(link_default.a, Object(esm_extends["a" /* default */])({
          href: href
        }, routeProps), ZoneLink_jsx("a", Object(esm_extends["a" /* default */])({
          id: "main-destination-main"
        }, linkProps, props), children));
      }
    }
  } else {
    return ZoneLink_jsx("div", props, children);
  }
};

/* harmony default export */ var components_ZoneLink = (ZoneLink_ZoneLink);
// CONCATENATED MODULE: ./src/components/Nav/SubNav.jsx



var SubNav_jsx = react_default.a.createElement;

function SubNav_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function SubNav_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { SubNav_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { SubNav_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










/**
 * The Nav nodes within the dropdown
 */

var SubNav_SubNavNode = function SubNavNode(_ref) {
  var icon = _ref.icon,
      nodeTitle = _ref.nodeTitle,
      href = _ref.href,
      zone = _ref.zone,
      hoc = _ref.hoc,
      description = _ref.description,
      scheme = _ref.scheme,
      callout = _ref.callout,
      nodeCount = _ref.nodeCount,
      isFirst = _ref.isFirst;

  var _useNavContext = useNavContext(),
      setValues = _useNavContext.setValues;

  var descriptions = compact_default()(Array.isArray(description) ? description : [description]);

  var trackNavClick = function trackNavClick() {
    analytics["g" /* default */].track(analytics["a" /* CLICK_NAV_LINK */], {
      href: href
    });
  };

  var contentProps = {
    loading: false,
    nodeCount: nodeCount,
    isFirst: isFirst,
    icon: icon,
    scheme: scheme,
    nodeTitle: nodeTitle,
    callout: callout,
    descriptions: descriptions
  };

  if (hoc) {
    return hoc(Nav_NavLinkContent, contentProps);
  } else {
    return SubNav_jsx(components_ZoneLink, {
      zone: zone,
      href: href
    }, SubNav_jsx(Nav_NavLinkContent, Object(esm_extends["a" /* default */])({
      onClick: function onClick() {
        trackNavClick();
        setValues({
          open: false,
          activeSection: null
        });
      }
    }, contentProps)));
  }
};

var SubNav_SubNav = function SubNav(_ref2) {
  var subNavTitle = _ref2.title,
      nodes = _ref2.nodes,
      show = _ref2.show;
  var subNavWidth = Object(ui["r" /* getSubNavWidth */])(nodes);

  var _useNavContext2 = useNavContext(),
      values = _useNavContext2.values,
      setValues = _useNavContext2.setValues;

  var nodeClasses = classnames_default()("link db w-100 fl black-80", {
    "w-50-l": nodes.length > 1
  });
  return SubNav_jsx("div", {
    onMouseLeave: function onMouseLeave() {
      if (show) {
        setValues(SubNav_objectSpread(SubNav_objectSpread({}, values), {}, {
          activeSection: null
        }));
      }
    },
    className: style_default.a.dynamic([["2824040231", [ui["e" /* DESKTOP */], subNavWidth]]]) + " " + "menu__subNav w-100 absolute-l top-0-l left-0-l flex flex-column bg-white z-1"
  }, subNavTitle && SubNav_jsx("div", {
    className: style_default.a.dynamic([["2824040231", [ui["e" /* DESKTOP */], subNavWidth]]]) + " " + "f6 fw5 pa3 tracked dn dib-l"
  }, subNavTitle.toUpperCase()), SubNav_jsx("ul", {
    className: style_default.a.dynamic([["2824040231", [ui["e" /* DESKTOP */], subNavWidth]]]) + " " + "ma0 pa0 w-100 flex flex-wrap"
  }, nodes.map(function (_ref3, nodeIx) {
    var icon = _ref3.icon,
        title = _ref3.title,
        href = _ref3.href,
        zone = _ref3.zone,
        description = _ref3.description,
        scheme = _ref3.scheme,
        callout = _ref3.callout,
        hoc = _ref3.hoc;
    return SubNav_jsx("div", {
      key: nodeIx,
      className: style_default.a.dynamic([["2824040231", [ui["e" /* DESKTOP */], subNavWidth]]]) + " " + (nodeClasses || "")
    }, SubNav_jsx(SubNav_SubNavNode, {
      hoc: hoc,
      key: nodeIx,
      icon: icon,
      nodeTitle: title,
      href: href,
      zone: zone,
      description: description,
      scheme: scheme,
      callout: callout,
      nodeCount: nodes.length,
      isFirst: !nodeIx
    }));
  })), SubNav_jsx(style_default.a, {
    id: "2824040231",
    dynamic: [ui["e" /* DESKTOP */], subNavWidth]
  }, ["@media (min-width:".concat(ui["e" /* DESKTOP */], "px){.menu__subNav.__jsx-style-dynamic-selector{margin-top:54px;min-width:").concat(subNavWidth, "px;box-shadow:rgba(37,44,97,0.1) 0px 5px 15px 0px, rgba(37,44,97,0.05) 0px 0px 15px 0px, rgba(93,100,148,0.1) 0px 2px 4px 0px, rgba(93,100,148,0.024) 0px -4px 16px 0px;-webkit-transition:-webkit-transform 0.25s ease-out 0s,opacity 0.25s ease-out 0s;-webkit-transition:transform 0.25s ease-out 0s,opacity 0.25s ease-out 0s;transition:transform 0.25s ease-out 0s,opacity 0.25s ease-out 0s;}.menu__subNav.__jsx-style-dynamic-selector::after{right:inherit;left:24px;content:\"\";width:10px;height:10px;background-color:white;position:absolute;top:-5px;-webkit-transform:rotate(-45deg);-ms-transform:rotate(-45deg);transform:rotate(-45deg);margin:auto;}}")]));
};

/* harmony default export */ var Nav_SubNav = (SubNav_SubNav);
// EXTERNAL MODULE: ./src/utils/styles.js
var styles = __webpack_require__("oCA+");

// CONCATENATED MODULE: ./src/components/Nav/LinkNode.jsx



var LinkNode_jsx = react_default.a.createElement;

function LinkNode_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function LinkNode_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { LinkNode_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { LinkNode_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var ICON_DIMENSION = 52;
var ICON_STYLES = {
  height: ICON_DIMENSION,
  width: ICON_DIMENSION
};
/**
 * The top level navigation node e.g. Payment Links, Tutorial, Documentation
 */

var LinkNode_LinkNode = function LinkNode(_ref) {
  var href = _ref.href,
      hoc = _ref.hoc,
      routeProps = _ref.routeProps,
      linkProps = _ref.linkProps,
      IconComp = _ref.IconComp,
      label = _ref.label,
      zone = _ref.zone,
      isActive = _ref.isActive,
      highlight = _ref.highlight,
      subnav = _ref.subnav,
      sectionId = _ref.sectionId,
      callout = _ref.callout,
      closeMenu = _ref.closeMenu,
      showAlways = _ref.showAlways;

  var _useNavContext = useNavContext(),
      values = _useNavContext.values,
      setValues = _useNavContext.setValues;

  var activeSection = values.activeSection;
  /**
   * Show
   * - Mobile - always want to show the subnav - as opposed to only on hover
   * - Debug - for desktop debuging / dev set this to true
   */
  // const show = true;

  var show = showAlways || activeSection === sectionId;

  var calloutComp = callout && LinkNode_jsx(Pill["a" /* default */], {
    copy: callout,
    customClasses: {
      container: "pl2",
      copy: "f7 bg-black-05 pa1 br2 fw5 flex-shrink-0 ph2 fw6"
    }
  });

  var content = IconComp ? LinkNode_jsx(IconComp, ICON_STYLES) : label;

  var mainContent = LinkNode_jsx("div", {
    className: "flex flex-row items-center"
  }, content, calloutComp);

  var trackNavClick = function trackNavClick() {
    analytics["g" /* default */].track(analytics["a" /* CLICK_NAV_LINK */], {
      href: href
    });
  };
  /**
   * If href
   * - if zone tag is a tag else Link tag
   */


  var linkContent;

  if (href) {
    linkProps.onClick = function () {
      trackNavClick();

      if (show) {
        setValues({
          close: true,
          activeSection: null
        });
      }
    };

    var flexLinkProps = {
      routeProps: routeProps,
      linkProps: linkProps,
      href: href,
      zone: zone
    };
    linkContent = LinkNode_jsx(components_ZoneLink, flexLinkProps, mainContent);
  } else if (hoc) {
    linkContent = hoc(function (_ref2) {
      var onClick = _ref2.onClick;
      return LinkNode_jsx("div", Object(esm_extends["a" /* default */])({
        className: "pointer link",
        onClick: onClick
      }, linkProps), mainContent);
    });
  } else {
    linkContent = LinkNode_jsx("div", linkProps, mainContent);
  }

  return LinkNode_jsx("div", {
    className: classnames_default()("relative z-2 h-100-l", {
      "z-6": show,
      "z-2": !show
    })
  }, LinkNode_jsx("li", {
    onMouseEnter: function onMouseEnter() {
      setValues(LinkNode_objectSpread(LinkNode_objectSpread({}, values), {}, {
        activeSection: sectionId
      }));
    },
    className: style_default.a.dynamic([["3035586638", [styles["a" /* COLORS */].primary, isActive && highlight ? styles["a" /* COLORS */].water_blue : styles["a" /* COLORS */].white, styles["a" /* COLORS */].primary, styles["a" /* COLORS */].whitesmoke]]]) + " " + "navLink pointer ph0 ph2-l dib h-100 flex items-center bb w-100 relative user-select-n bg-white--hover"
  }, linkContent, LinkNode_jsx(style_default.a, {
    id: "3035586638",
    dynamic: [styles["a" /* COLORS */].primary, isActive && highlight ? styles["a" /* COLORS */].water_blue : styles["a" /* COLORS */].white, styles["a" /* COLORS */].primary, styles["a" /* COLORS */].whitesmoke]
  }, [".navLink.__jsx-style-dynamic-selector{border-width:0.2rem;outline:none;color:".concat(styles["a" /* COLORS */].primary, ";border-color:").concat(isActive && highlight ? styles["a" /* COLORS */].water_blue : styles["a" /* COLORS */].white, ";}"), ".navLink__label.__jsx-style-dynamic-selector{color:".concat(styles["a" /* COLORS */].primary, ";}"), ".navLink__label.__jsx-style-dynamic-selector:hover{background-color:".concat(styles["a" /* COLORS */].whitesmoke, ";}")])), subnav && show && LinkNode_jsx(Nav_SubNav, Object(esm_extends["a" /* default */])({
    key: href,
    show: show,
    closeMenu: closeMenu
  }, subnav)));
};

/* harmony default export */ var Nav_LinkNode = (LinkNode_LinkNode);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__("20a2");

// EXTERNAL MODULE: ./src/components/Form/fields/Button.js + 1 modules
var Button = __webpack_require__("TEwj");

// EXTERNAL MODULE: ./src/actions/auth.js + 1 modules
var auth = __webpack_require__("nSkU");

// EXTERNAL MODULE: ./src/utils/paths.js
var paths = __webpack_require__("5mj7");

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__("/MKj");

// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 15 modules
var redux_es = __webpack_require__("fvjX");

// EXTERNAL MODULE: ./src/utils/selectors.js + 2 modules
var selectors = __webpack_require__("3WHN");

// CONCATENATED MODULE: ./src/components/Nav/AuthButton.jsx


var AuthButton_jsx = react_default.a.createElement;

function AuthButton_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function AuthButton_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { AuthButton_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { AuthButton_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var DEFAULT_CLASSES = {
  contextClass: " ",
  button: "bn bg-transparent f4 f5-l pa3 pa2-l pointer br2 w-100 outline-0 link color-text--primary fw5 bg-white--hover dib"
};
/**
 * In main
 * - login - relative /login path
 * - logout - replace route
 * In a zone
 * - login - absolute /login path
 * - logout - no route replacement
 */

var AuthButton_AuthButton = function AuthButton(_ref) {
  var actions = _ref.actions,
      customClasses = _ref.customClasses;

  var _useNavContext = useNavContext(),
      values = _useNavContext.values,
      setValues = _useNavContext.setValues;

  var classes = AuthButton_objectSpread(AuthButton_objectSpread({}, DEFAULT_CLASSES), customClasses);

  var isAuthed = Object(selectors["o" /* useIsAuthed */])();

  var _useRouter = Object(next_router["useRouter"])(),
      replace = _useRouter.replace;

  var currentlyInZone = nav_isZone();
  var buttonProps = {
    theme: "slim",
    copy: isAuthed ? "Logout" : "Login"
  };

  if (isAuthed) {
    buttonProps.tag = ui["b" /* BUTTON_TAGS */].BUTTON;

    buttonProps.onClick = function () {
      actions.logout();
      setValues(AuthButton_objectSpread(AuthButton_objectSpread({}, values), {}, {
        open: false
      }));
      /**
       * Only redirect to login if not in a zone
       */

      if (!currentlyInZone) {
        replace(paths["d" /* default */].LOGIN);
      }
    };
  } else {
    buttonProps.tag = currentlyInZone ? ui["b" /* BUTTON_TAGS */].ANCHOR : ui["b" /* BUTTON_TAGS */].LINK;
    buttonProps.href = Object(utils_route["a" /* getMainAppPath */])(paths["d" /* default */].LOGIN);
  }

  return AuthButton_jsx(Button["a" /* default */], Object(esm_extends["a" /* default */])({
    id: "auth-button"
  }, buttonProps, {
    classes: classes
  }));
};

var AuthButton_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(redux_es["bindActionCreators"])({
      logout: auth["c" /* logout */]
    }, dispatch)
  };
};

/* harmony default export */ var Nav_AuthButton = (Object(es["b" /* connect */])(null, AuthButton_mapDispatchToProps)(AuthButton_AuthButton));
// EXTERNAL MODULE: ./src/utils/mapStateToProps.js + 5 modules
var mapStateToProps = __webpack_require__("WnXJ");

// EXTERNAL MODULE: ./src/components/Image/index.jsx + 2 modules
var Image = __webpack_require__("W56c");

// CONCATENATED MODULE: ./src/components/Icons/brand.js
var brand_jsx = react_default.a.createElement;




var brand_Brand = function Brand() {
  return brand_jsx(Image["a" /* default */], {
    src: "".concat(Object(env["a" /* getConfig */])("BASE_PATH"), "/assets/brand.png"),
    width: "40",
    height: "40",
    alt: "PriceBlocs Logo"
  });
};

/* harmony default export */ var brand = (brand_Brand);
// EXTERNAL MODULE: ./node_modules/react-toast-notifications/dist/index.js
var dist = __webpack_require__("tbn6");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("o0o1");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("HaE+");

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("vDqi");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/lodash/isError.js
var isError = __webpack_require__("PtqM");
var isError_default = /*#__PURE__*/__webpack_require__.n(isError);

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("E+oP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__("mwIZ");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__("Qyje");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/lodash/omit.js
var omit = __webpack_require__("Puqe");
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);

// EXTERNAL MODULE: ./node_modules/lodash/trimStart.js
var trimStart = __webpack_require__("Fob7");
var trimStart_default = /*#__PURE__*/__webpack_require__.n(trimStart);

// CONCATENATED MODULE: ./src/utils/url.js





var HTTPS_RE = new RegExp(/^(https:\/\/|https:\/|)/gi);
var HTTP_RE = new RegExp(/^http:\/\//gi);
var HASH_START_RE = new RegExp(/^#/);
var HTTPS = "https://";
var HTTP = "http://";
var url_createURL = function createURL(state) {
  return "?".concat(lib_default.a.stringify(state));
};
var url_defaultHttps = function defaultHttps(href) {
  if (href && !HASH_START_RE.test(href)) {
    var isInsecureTarget = compact_default()(href.match(HTTP_RE));
    var prefix = isInsecureTarget.length ? HTTP : HTTPS;
    var secureMatches = compact_default()(href.match(HTTPS_RE));
    var suffix;

    if (secureMatches.length) {
      var memoCopy = href;
      suffix = secureMatches.reduce(function (memo, match) {
        memo = memo.replace(match, "");
        return memo;
      }, memoCopy);
    } else {
      var parts = href.split(":/");
      var sliceIndex = parts.length > 1 ? 1 : 0;
      suffix = parts.slice(sliceIndex).join("");
    }

    return "".concat(prefix).concat(trimStart_default()(suffix, "/"));
  } else {
    return "";
  }
};
var HREF_TYPE = {
  LINK: "link",
  MAILTO: "mailto",
  TEL: "tel"
};
var setHrefWithType = function setHrefWithType(_ref) {
  var href = _ref.href,
      hrefType = _ref.hrefType;
  return hrefType && hrefType !== HREF_TYPE.LINK ? "".concat(hrefType, ":").concat(href) : url_defaultHttps(href);
};
var url_omitQueryStringKeys = function omitQueryStringKeys(url, keys) {
  var urlParts = url.split("?");

  if (urlParts[1]) {
    var parts = lib_default.a.parse(urlParts[1]);
    var remainder = omit_default()(parts, keys);
    return isEmpty_default()(remainder) ? urlParts[0] : "".concat(urlParts[0], "?").concat(lib_default.a.stringify(remainder));
  } else {
    return url;
  }
};
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/sdk.js
var sdk = __webpack_require__("3CEA");

// EXTERNAL MODULE: ./node_modules/@sentry/minimal/esm/index.js
var esm = __webpack_require__("gtzJ");

// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__("sEfC");
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);

// EXTERNAL MODULE: ./src/utils/subdomain.js
var utils_subdomain = __webpack_require__("c9Rf");

// CONCATENATED MODULE: ./src/utils/constants/error.js
var GENERIC_ERROR = {
  title: "Whoops!",
  body: ["There was an error loading this page.", "Please refresh to try again."]
};
var CHECKOUT_SESSION_ERROR_CONTENT = {
  title: "Whoops!",
  body: ["There was an error loading your order summary.", "Please refresh to try again."]
};
var CHECKOUT_CONTENT_ERROR_CONTENT = {
  title: "Whoops!",
  body: ["There was an error loading your content.", "Please refresh to try again. Or click the download content link in the email you received."]
};
var CHECKOUT_CONTENT_NO_DATA_CONTENT = {
  title: "No content",
  body: ["Please check your email for a link to download your content."]
};
var CHECKOUT_GENERIC_ERROR_CONTENT = {
  title: "Whoops!",
  body: ["There was an error with your checkout.", "Close the page and try again."]
};
// CONCATENATED MODULE: ./src/utils/constants/header.js
var USER_AGENT = "user-agent";
var X_REFERER = "x-referer";
var X_USER_AGENT = "x-".concat(USER_AGENT);
var X_API_KEY = "x-api-key";
// CONCATENATED MODULE: ./src/utils/render.js









var renderSubdomainRoute = /*#__PURE__*/function () {
  var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref) {
    var apiKey, query, url, _yield$axios, data;

    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            apiKey = _ref.apiKey, query = Object(objectWithoutProperties["a" /* default */])(_ref, ["apiKey"]);
            url = "".concat("https://api.priceblocs.com", "/v1/render?").concat(lib_default.a.stringify(query));
            _context.prev = 2;
            _context.next = 5;
            return axios_default()({
              method: "get",
              url: url,
              headers: Object(defineProperty["a" /* default */])({}, X_API_KEY, apiKey)
            });

          case 5:
            _yield$axios = _context.sent;
            data = _yield$axios.data;
            return _context.abrupt("return", data);

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](2);
            return _context.abrupt("return", _context.t0);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 10]]);
  }));

  return function renderSubdomainRoute(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var renderSubdomainDocument = /*#__PURE__*/function () {
  var _ref4 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee2(_ref3) {
    var apiKey, query, url, _yield$axios$get, data;

    return regenerator_default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            apiKey = _ref3.apiKey, query = Object(objectWithoutProperties["a" /* default */])(_ref3, ["apiKey"]);
            url = "".concat("https://api.priceblocs.com", "/v1/document?").concat(lib_default.a.stringify(query));
            _context2.prev = 2;
            _context2.next = 5;
            return axios_default.a.get({
              url: url,
              headers: Object(defineProperty["a" /* default */])({}, X_API_KEY, apiKey)
            });

          case 5:
            _yield$axios$get = _context2.sent;
            data = _yield$axios$get.data;
            return _context2.abrupt("return", data);

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](2);
            return _context2.abrupt("return", _context2.t0);

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 10]]);
  }));

  return function renderSubdomainDocument(_x2) {
    return _ref4.apply(this, arguments);
  };
}();
var SHORT_LINK = "shortLink";
var CONTENT = "content";
var ADMIN = "admin";
var METADATA = "metadata";
var SHORT_ID = "shortId";
var CAPABILITIES = "capabilities";
var MANIFEST = "manifest";
var THEME = "theme";
var INTEGRATIONS = "integrations";
var SESSION = "session";
var SUBSCRIPTION = "subscription";
var ITEMS = "items";
var ACCOUNT = "account";
var ORGANIZATION = "organization";
var COLLAPSE_IMAGES = "collapseImages";
var CHECKOUT = "checkout";
var ATTACHMENTS = "attachments";
var PROP_KEYS = {
  SHORT_LINK: SHORT_LINK,
  CONTENT: CONTENT,
  ADMIN: ADMIN,
  METADATA: METADATA,
  SHORT_ID: SHORT_ID,
  CAPABILITIES: CAPABILITIES,
  MANIFEST: MANIFEST,
  THEME: THEME,
  INTEGRATIONS: INTEGRATIONS,
  SESSION: SESSION,
  SUBSCRIPTION: SUBSCRIPTION,
  ITEMS: ITEMS,
  ACCOUNT: ACCOUNT,
  ORGANIZATION: ORGANIZATION,
  COLLAPSE_IMAGES: COLLAPSE_IMAGES,
  CHECKOUT: CHECKOUT,
  ATTACHMENTS: ATTACHMENTS
};
var COMMON_CHECKOUT_KEYS = [PROP_KEYS.ACCOUNT, PROP_KEYS.THEME, PROP_KEYS.CONTENT, PROP_KEYS.ORGANIZATION, PROP_KEYS.ITEMS, PROP_KEYS.SUBSCRIPTION, PROP_KEYS.SESSION, PROP_KEYS.COLLAPSE_IMAGES, PROP_KEYS.CHECKOUT, PROP_KEYS.ATTACHMENTS];
var PAGE_KEYS = {
  HOME: [PROP_KEYS.SHORT_LINK],
  LINKS: {
    EVALUATE: [PROP_KEYS.ADMIN, PROP_KEYS.CONTENT, PROP_KEYS.METADATA, PROP_KEYS.SHORT_ID, PROP_KEYS.CAPABILITIES],
    SHOW: [PROP_KEYS.SHORT_LINK]
  },
  PRICING: [PROP_KEYS.MANIFEST, PROP_KEYS.THEME, PROP_KEYS.ACCOUNT, PROP_KEYS.CONTENT, PROP_KEYS.INTEGRATIONS, PROP_KEYS.CAPABILITIES, PROP_KEYS.METADATA],
  CHECKOUT: {
    ERROR: COMMON_CHECKOUT_KEYS,
    SUCCESS: COMMON_CHECKOUT_KEYS,
    CONTENT: COMMON_CHECKOUT_KEYS
  }
};
var render_preparePageResponse = function preparePageResponse(_ref5) {
  var data = _ref5.data,
      params = _ref5.params,
      keys = _ref5.keys,
      errorContent = _ref5.errorContent,
      xHeaders = _ref5.xHeaders;
  var response = {
    xHeaders: xHeaders || {}
  };
  var error = isError_default()(data);

  if (error) {
    console.error("[ERROR] render page props %s with error %s", params, data);
  }

  if (error) {
    response.error = errorContent || GENERIC_ERROR;
  } else {
    keys.forEach(function (key) {
      if (data && data[key]) {
        response[key] = data[key];
      }
    });

    if (params) {
      response.config = params;
    }
  }

  return response;
};
// CONCATENATED MODULE: ./src/utils/error.js




function error_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function error_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { error_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { error_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var DIALOG_CLASS_NAME = "sentry-error-embed-wrapper";
var debouncedDialog = debounce_default()(function (event, user) {
  sdk["h" /* showReportDialog */](error_objectSpread({
    eventId: event.event_id
  }, user));
}, 500);
var showErrorDialog = function showErrorDialog(user) {
  return function (event) {
    var notShown = document.getElementsByClassName(DIALOG_CLASS_NAME).length === 0;
    /**
     * Check if it is an exception, and if so, show the report dialog
     * Ensure not show too many times by debouncing
     * */

    if (event.exception && notShown) {
      debouncedDialog(event, user);
    }

    return event;
  };
};
var error_captureException = function captureException(error) {
  return  true && esm["c" /* captureException */](error);
};
var getErrorServerSideProps = /*#__PURE__*/function () {
  var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref) {
    var req, query, params, REQUEST_URL, data, response;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            req = _ref.req, query = _ref.query;

            /**
             * 1. Get subdomain params for query
             */
            params = Object(utils_subdomain["b" /* subdomainParamsFromReq */])({
              req: req
            });
            /**
             * 2. Get test / live link request route
             * - extended with query params
             * - e.g. /v1/stripe/checkout/error?shortId=abc
             */

            REQUEST_URL = "".concat(paths["a" /* API_PATHS */].CHECKOUT_ERROR, "?").concat(lib_default.a.stringify({
              subdomain: params.subdomain,
              shortId: query.shortId
            }));
            /**
             * 3. Render checkout error page summary for live / test context
             * - This is a GET to the provided url
             * - Generate the checkout payload on the server to prevent leaking of Stripe models to the client
             */

            _context.next = 5;
            return renderStripeCheckoutError(REQUEST_URL);

          case 5:
            data = _context.sent;

            /**
             * 4. Prepare response shape data
             */
            response = render_preparePageResponse({
              data: data,
              params: params,
              keys: PAGE_KEYS.CHECKOUT.ERROR,
              errorContent: CHECKOUT_SESSION_ERROR_CONTENT
            });
            return _context.abrupt("return", {
              props: response
            });

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getErrorServerSideProps(_x) {
    return _ref2.apply(this, arguments);
  };
}();
// EXTERNAL MODULE: ./src/utils/auth.js
var utils_auth = __webpack_require__("X4fA");

// EXTERNAL MODULE: ./src/utils/debug.js
var debug = __webpack_require__("Djx3");

// CONCATENATED MODULE: ./src/utils/constants/stripe.js


var _STRIPE_OAUTH_ERROR_C;

var STRIPE_SESSION_ID_QS_PARAM = "session_id={CHECKOUT_SESSION_ID}";
var ACCESS_DENIED = "access_denied";
var INVALID_SCOPE = "invalid_scope";
var INVALID_REDIRECT_URI = "invalid_redirect_uri";
var INVALID_REQUEST = "invalid_request";
var UNSUPPORTED_RESPONSE_TYPE = "unsupported_response_type";
var STRIPE_OAUTH_ERROR_CONTENT = (_STRIPE_OAUTH_ERROR_C = {}, Object(defineProperty["a" /* default */])(_STRIPE_OAUTH_ERROR_C, ACCESS_DENIED, {
  title: "Authorization denied",
  body: ["That authorization failed. Click to try again."]
}), Object(defineProperty["a" /* default */])(_STRIPE_OAUTH_ERROR_C, INVALID_REQUEST, {
  title: "Request error",
  body: ["There was a problem with that request. Click to try again."]
}), _STRIPE_OAUTH_ERROR_C); // https://stripe.com/docs/connect/oauth-reference#get-authorize-error-codes

var STRIPE_OAUTH_ERROR = {
  ACCESS_DENIED: ACCESS_DENIED,
  INVALID_SCOPE: INVALID_SCOPE,
  INVALID_REDIRECT_URI: INVALID_REDIRECT_URI,
  INVALID_REQUEST: INVALID_REQUEST,
  UNSUPPORTED_RESPONSE_TYPE: UNSUPPORTED_RESPONSE_TYPE
};
var STRIPE_ROUTES = {
  ACCOUNT: "settings/account",
  BRANDING: "setings/branding",
  UPDATE: "setings/update",
  VERIFICATIONS: "setings/verifications",
  PRODUCTS: "products",
  PAYMENT_METHODS: "settings/payments"
};
var STRIPE_BENEFITS_LIST = [{
  icon: "checkmarkCircle",
  copy: "PCI DSS compliance Level 1 certification."
}, {
  icon: "checkmarkCircle",
  copy: "Money Transmitter Licenses across US."
}, {
  icon: "checkmarkCircle",
  copy: "PSD2 and Strong Customer Authentication (SCA) compliant."
}];
var STRIPE_IDENTITY_LIST = [{
  icon: "store",
  copy: "Business information and identification."
}, {
  icon: "bank",
  copy: "Bank account information."
}, {
  icon: "globe",
  copy: "Website information and verification."
}];
var SELL_ANYTHING_LIST = [{
  icon: "checkmarkCircle",
  copy: "Create one time or recurring charges."
}, {
  icon: "checkmarkCircle",
  copy: "Set prices in different currencies."
}, {
  icon: "checkmarkCircle",
  copy: "Accept Apple Pay and Google Pay."
}, {
  icon: "checkmarkCircle",
  copy: "Apply discounts, tax rates and more."
}];
var SELL_ANYWHERE_LIST = [{
  icon: "checkmarkCircle",
  copy: "Accept payments in your customers preferred payment method including Apple Pay and Google Wallet."
}, {
  icon: "checkmarkCircle",
  copy: "Compatible with most CRM and marketing apps."
}, {
  icon: "checkmarkCircle",
  copy: "QR codes to enable contactless payments."
}];
var STRIPE_LIST_SECTIONS = [{
  header: "Sell anything",
  notation: "*",
  body: "Accept payments for any of your products with payment links. Each link can be configured for your use case.",
  list: SELL_ANYTHING_LIST
}, {
  header: "Sell anywhere",
  body: "Commerce is happening internationally, across multiple channels. Payment links are global and omnichannel ready, allowing you to sell across email, social, in app etc. Payment links can help you sell wherever your customers are.",
  list: SELL_ANYWHERE_LIST
}, {
  header: "Simple and secure",
  body: "Meet the latest regulatory and compliance requirements through Stripe including built in fraud detection.",
  list: STRIPE_BENEFITS_LIST
}];
var METADATA_FLEX_PRODUCT = "__PB_FLEX_PRODUCT";
// CONCATENATED MODULE: ./src/utils/checkout.js




















var QS_OMISSION_KEYS = ["celebrate"];
var getCheckoutScaffold = function getCheckoutScaffold() {
  return {
    payment_method_types: ["card"],
    allow_promotion_codes: false,
    discounts: [],
    customer: "",
    customer_email: "",
    tax_rates: [],
    shipping_worldwide: false // payment_method_types: ["card"],
    // dynamic_tax_rates: []
    // billing_address_collection,
    // shipping_address_collection,
    // submit_type

  };
};
/**
 * Get metadata and client account details
 */

var renderLinksRoute = /*#__PURE__*/function () {
  var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref) {
    var apiKey, url, referer, userAgent, headers, _yield$axios, data;

    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            apiKey = _ref.apiKey, url = _ref.url, referer = _ref.referer, userAgent = _ref.userAgent;
            _context.prev = 1;
            headers = Object(defineProperty["a" /* default */])({}, X_API_KEY, apiKey); // proxy.referer
            // "x-referer": "https://l.instagram.com",
            // proxy.userAgent
            // "x-user-agent": "WhatsApp",

            if (referer) {
              headers[X_REFERER] = referer;
            }

            if (userAgent) {
              headers[X_USER_AGENT] = userAgent;
            }

            _context.next = 7;
            return axios_default()({
              method: "get",
              url: url,
              headers: headers
            });

          case 7:
            _yield$axios = _context.sent;
            data = _yield$axios.data;
            return _context.abrupt("return", data);

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", _context.t0);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 12]]);
  }));

  return function renderLinksRoute(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var fetchPageResponse = /*#__PURE__*/function () {
  var _ref3 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee2(url) {
    var _yield$axios$get, data;

    return regenerator_default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return axios_default.a.get(url);

          case 3:
            _yield$axios$get = _context2.sent;
            data = _yield$axios$get.data;
            return _context2.abrupt("return", data);

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", _context2.t0);

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 8]]);
  }));

  return function fetchPageResponse(_x2) {
    return _ref3.apply(this, arguments);
  };
}();
var renderStripeCheckoutError = /*#__PURE__*/function () {
  var _ref4 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee3(url) {
    var _yield$axios$get2, data;

    return regenerator_default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return axios_default.a.get(url);

          case 3:
            _yield$axios$get2 = _context3.sent;
            data = _yield$axios$get2.data;
            return _context3.abrupt("return", data);

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](0);
            return _context3.abrupt("return", _context3.t0);

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 8]]);
  }));

  return function renderStripeCheckoutError(_x3) {
    return _ref4.apply(this, arguments);
  };
}();
/**
 * Build the sesssion checkout params - ensure client side UI side effect params like celebrate are omitted
 * @param {Object} params
 * @param {Object} params.subdomain - app subdomain
 * @param {Object} params.price - price id
 * @param {Object} params.cancelUrl - optional cancel url, defaults to current location
 * @param {Object} params.checkout - checkout specific params like encrypted session
 * @param {Object} params.tracking - object of tracking params
 */

var checkout_getSessionParams = function getSessionParams(_ref5) {
  var subdomain = _ref5.subdomain,
      price = _ref5.price,
      cancelUrl = _ref5.cancelUrl,
      checkout = _ref5.checkout,
      tracking = _ref5.tracking;
  return {
    subdomain: subdomain,
    price: price,
    cancelUrl: url_omitQueryStringKeys(cancelUrl || window.location.href, QS_OMISSION_KEYS),
    checkout: checkout,
    tracking: tracking
  };
};
var getPriceCheckoutSession = /*#__PURE__*/function () {
  var _ref7 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee4(_ref6) {
    var subdomain, price, cancelUrl, checkout, tracking, requestParams, _yield$axios2, data;

    return regenerator_default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            subdomain = _ref6.subdomain, price = _ref6.price, cancelUrl = _ref6.cancelUrl, checkout = _ref6.checkout, tracking = _ref6.tracking;
            requestParams = {
              subdomain: subdomain,
              price: price,
              cancelUrl: cancelUrl,
              checkout: checkout,
              tracking: tracking
            };
            Object(debug["a" /* devLogger */])("getPriceCheckoutSession.request.params", requestParams);
            _context4.prev = 3;
            _context4.next = 6;
            return axios_default()({
              method: "post",
              url: paths["a" /* API_PATHS */].CHECKOUT,
              data: requestParams
            });

          case 6:
            _yield$axios2 = _context4.sent;
            data = _yield$axios2.data;
            return _context4.abrupt("return", data);

          case 11:
            _context4.prev = 11;
            _context4.t0 = _context4["catch"](3);
            return _context4.abrupt("return", _context4.t0);

          case 14:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[3, 11]]);
  }));

  return function getPriceCheckoutSession(_x4) {
    return _ref7.apply(this, arguments);
  };
}();
/**
 * Fetch checkout session for subdomain price
 * - The redirect to checkout
 * @param {Object} params
 * @param {Object} params.stripe
 * @param {Function} params.setLoading
 * @param {String} params.subdomain
 * @param {String} params.price
 */

var checkout_checkoutPrice = function checkoutPrice(_ref8) {
  var stripe = _ref8.stripe,
      setLoading = _ref8.setLoading,
      subdomain = _ref8.subdomain,
      price = _ref8.price,
      checkout = _ref8.checkout,
      tracking = _ref8.tracking;
  return /*#__PURE__*/Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
    var session;
    return regenerator_default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            setLoading(true);
            _context5.prev = 1;
            _context5.next = 4;
            return getPriceCheckoutSession(checkout_getSessionParams({
              subdomain: subdomain,
              price: price,
              checkout: checkout,
              tracking: tracking
            }));

          case 4:
            session = _context5.sent;

            if (stripe) {
              stripe.redirectToCheckout({
                sessionId: session.id
              });
            } else {
              error_captureException(new Error("No Stripe for price checkout"));
            }

            setLoading(false);
            _context5.next = 13;
            break;

          case 9:
            _context5.prev = 9;
            _context5.t0 = _context5["catch"](1);
            setLoading(false);
            throw _context5.t0;

          case 13:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[1, 9]]);
  }));
};
var checkoutShortLink = /*#__PURE__*/function () {
  var _ref11 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee6(_ref10) {
    var stripe, url, setLoading, setError, setContent, xHeaders, requestInput, _yield$axios3, data;

    return regenerator_default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            stripe = _ref10.stripe, url = _ref10.url, setLoading = _ref10.setLoading, setError = _ref10.setError, setContent = _ref10.setContent, xHeaders = _ref10.xHeaders;
            setLoading(true);
            _context6.prev = 2;
            requestInput = {
              method: "get",
              url: url
            };

            if (!isEmpty_default()(xHeaders)) {
              requestInput.headers = xHeaders;
            }

            _context6.next = 7;
            return axios_default()(requestInput);

          case 7:
            _yield$axios3 = _context6.sent;
            data = _yield$axios3.data;

            if (data) {
              if (data.session && data.session.id) {
                if (stripe) {
                  stripe.redirectToCheckout({
                    sessionId: data.session.id
                  });
                } else {
                  error_captureException(new Error("No Stripe for price checkout"));
                }
              } else if (data.content) {
                setContent(data.content);
              }
            }

            setLoading(false);
            _context6.next = 17;
            break;

          case 13:
            _context6.prev = 13;
            _context6.t0 = _context6["catch"](2);
            setLoading(false);
            setError(_context6.t0);

          case 17:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[2, 13]]);
  }));

  return function checkoutShortLink(_x5) {
    return _ref11.apply(this, arguments);
  };
}(); // =================================================
// BILLING
// https://stripe.com/docs/api/customer_portal/create
// =================================================

var buildBillingParams = function buildBillingParams(_ref12) {
  var customer = _ref12.customer;
  return {
    customer: customer,
    return_url: true ? window.location.href : undefined
  };
};
var getBillingSession = /*#__PURE__*/function () {
  var _ref13 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee7(session) {
    var PUB_KEY, _yield$axios4, data;

    return regenerator_default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            PUB_KEY = Object(env["a" /* getConfig */])("PRICE_BLOCS_PUB_KEY");
            _context7.prev = 1;
            _context7.next = 4;
            return axios_default()({
              method: "post",
              url: paths["a" /* API_PATHS */].BILLING_SESSION,
              headers: {
                Authorization: "Bearer ".concat(PUB_KEY)
              },
              data: {
                session: session
              }
            });

          case 4:
            _yield$axios4 = _context7.sent;
            data = _yield$axios4.data;
            return _context7.abrupt("return", data);

          case 9:
            _context7.prev = 9;
            _context7.t0 = _context7["catch"](1);
            return _context7.abrupt("return", _context7.t0);

          case 12:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[1, 9]]);
  }));

  return function getBillingSession(_x6) {
    return _ref13.apply(this, arguments);
  };
}();
/**
 * Fetch billing session
 * - Then redirect to billing portal page
 * @param {Object} params
 * @param {Object} params.session
 * @param {Function} params.setLoading
 */

var checkout_billing = function billing(_ref14) {
  var session = _ref14.session,
      setLoading = _ref14.setLoading,
      setError = _ref14.setError;
  return /*#__PURE__*/Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
    var billingSession;
    return regenerator_default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            setLoading(true);
            _context8.prev = 1;
            _context8.next = 4;
            return getBillingSession(session);

          case 4:
            billingSession = _context8.sent;

            if (isError_default()(billingSession)) {
              setError && setError(billingSession);
              error_captureException(billingSession);
            } else if (billingSession && billingSession.url) {
              window.location.href = billingSession.url;
            }

            setLoading(false);
            _context8.next = 14;
            break;

          case 9:
            _context8.prev = 9;
            _context8.t0 = _context8["catch"](1);
            setError && setError(_context8.t0);
            setLoading(false);
            throw _context8.t0;

          case 14:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[1, 9]]);
  }));
}; // =================================================
// CHECKOUT
// https://stripe.com/docs/api/checkout/sessions/object
// ================================================

var checkout_buildCheckoutParams = function buildCheckoutParams(_ref16) {
  var customer = _ref16.customer,
      resource = _ref16.resource,
      resourceUUID = _ref16.resourceUUID,
      successUrl = _ref16.successUrl;
  var success_url = successUrl ? "".concat(successUrl, "?").concat(STRIPE_SESSION_ID_QS_PARAM) : "";

  if (true) {
    var hrefParts = window.location.href.split("?");

    if (!success_url) {
      success_url = "".concat(hrefParts[0], "?").concat(STRIPE_SESSION_ID_QS_PARAM);

      if (hrefParts[1]) {
        success_url += "&".concat(hrefParts[1]);
      }
    } else {
      success_url += "&return_to=".concat(window.location.pathname);
    }
  }

  return {
    customer: customer,
    client_reference_id: resourceUUID,
    success_url: success_url,

    /**
     * Set resource in subscription metadata so that we can perform a lookup and association when processing webhooks
     */
    subscription_data: {
      metadata: {
        resourceUUID: resourceUUID,
        resource: resource
      }
    }
  };
};
var getCheckoutSession = /*#__PURE__*/function () {
  var _ref17 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee9(session) {
    var PUB_KEY, _yield$axios5, data;

    return regenerator_default.a.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            PUB_KEY = Object(env["a" /* getConfig */])("PRICE_BLOCS_PUB_KEY");
            _context9.prev = 1;
            _context9.next = 4;
            return axios_default()({
              method: "post",
              url: paths["a" /* API_PATHS */].CHECKOUT_SESSION,
              headers: {
                Authorization: "Bearer ".concat(PUB_KEY)
              },
              data: {
                session: session
              }
            });

          case 4:
            _yield$axios5 = _context9.sent;
            data = _yield$axios5.data;
            return _context9.abrupt("return", data);

          case 9:
            _context9.prev = 9;
            _context9.t0 = _context9["catch"](1);
            return _context9.abrupt("return", _context9.t0);

          case 12:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[1, 9]]);
  }));

  return function getCheckoutSession(_x7) {
    return _ref17.apply(this, arguments);
  };
}();
/**
 * Fetch checkout session
 * - Then redirect to pricing page with encrypted session
 * @param {Object} params
 * @param {Object} params.session
 * @param {Function} params.setLoading
 */

var checkout_checkout = function checkout(_ref18) {
  var session = _ref18.session,
      setLoading = _ref18.setLoading,
      setError = _ref18.setError;
  return /*#__PURE__*/Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee10() {
    var sealedSession, href;
    return regenerator_default.a.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            setLoading(true);
            _context10.prev = 1;
            _context10.next = 4;
            return getCheckoutSession(session);

          case 4:
            sealedSession = _context10.sent;
            href = "".concat(Object(env["a" /* getConfig */])("WEB_CLIENT_ROOT")).concat(paths["d" /* default */].PRICING);

            if (isError_default()(sealedSession)) {
              setError && setError(sealedSession);
              error_captureException(sealedSession);
            } else {
              href += "?session=".concat(sealedSession);
            }

            window.location.href = href;
            setLoading(false);
            _context10.next = 16;
            break;

          case 11:
            _context10.prev = 11;
            _context10.t0 = _context10["catch"](1);
            setError && setError(_context10.t0);
            setLoading(false);
            throw _context10.t0;

          case 16:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[1, 11]]);
  }));
};
var getCheckoutSuccessPreview = /*#__PURE__*/function () {
  var _ref21 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee11(_ref20) {
    var subdomain, url, response;
    return regenerator_default.a.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            subdomain = _ref20.subdomain;
            _context11.prev = 1;
            url = "".concat(paths["a" /* API_PATHS */].CHECKOUT_SUCCESS_PREVIEW, "?subdomain=").concat(subdomain);
            _context11.next = 5;
            return axios_default()({
              url: url,
              method: "get",
              headers: Object(utils_auth["a" /* authBearerToken */])()
            });

          case 5:
            response = _context11.sent;
            return _context11.abrupt("return", response.data);

          case 9:
            _context11.prev = 9;
            _context11.t0 = _context11["catch"](1);
            throw _context11.t0;

          case 12:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, null, [[1, 9]]);
  }));

  return function getCheckoutSuccessPreview(_x8) {
    return _ref21.apply(this, arguments);
  };
}();
var checkout_getCheckoutSuccessAPIRoute = function getCheckoutSuccessAPIRoute(_ref22) {
  var pathname = _ref22.pathname,
      query = _ref22.query;
  var path = Object(utils_route["g" /* isTestRoute */])(pathname) ? paths["a" /* API_PATHS */].TEST_CHECKOUT_SUCCESS : paths["a" /* API_PATHS */].CHECKOUT_SUCCESS;
  return "".concat(path, "?").concat(lib_default.a.stringify(query));
};
var checkout_getCheckoutContentAPIRoute = function getCheckoutContentAPIRoute(_ref23) {
  var pathname = _ref23.pathname,
      query = _ref23.query;
  var path = Object(utils_route["g" /* isTestRoute */])(pathname) ? paths["a" /* API_PATHS */].TEST_CHECKOUT_CONTENT : paths["a" /* API_PATHS */].CHECKOUT_CONTENT;
  return "".concat(path, "?").concat(lib_default.a.stringify(query));
};
var getCheckoutSuccessServerSideProps = /*#__PURE__*/function () {
  var _ref25 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee12(_ref24) {
    var req, query, params, REQUEST_URL, data, response;
    return regenerator_default.a.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            req = _ref24.req, query = _ref24.query;

            /**
             * 1. Get subdomain params for query
             */
            params = Object(utils_subdomain["b" /* subdomainParamsFromReq */])({
              req: req
            });
            /**
             * 2. Get test / live link request route
             * - extended with query params
             * - e.g. /v1/stripe/checkout/success?sessionId=abc
             */

            REQUEST_URL = checkout_getCheckoutSuccessAPIRoute({
              pathname: req.url,
              query: {
                subdomain: params.subdomain,
                sessionId: query.session_id
              }
            });
            /**
             * 3. Render checkout success page summary for live / test context
             * - This is a GET to the provided url
             * - Generate the checkout payload on the server to prevent leaking of Stripe models to the client
             */

            _context12.next = 5;
            return fetchPageResponse(REQUEST_URL);

          case 5:
            data = _context12.sent;

            /**
             * 4. Prepare response shape data
             */
            response = render_preparePageResponse({
              data: data,
              params: params,
              keys: PAGE_KEYS.CHECKOUT.SUCCESS,
              errorContent: CHECKOUT_SESSION_ERROR_CONTENT
            });
            return _context12.abrupt("return", {
              props: response
            });

          case 8:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));

  return function getCheckoutSuccessServerSideProps(_x9) {
    return _ref25.apply(this, arguments);
  };
}();
var getCheckoutContentServerSideProps = /*#__PURE__*/function () {
  var _ref27 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee13(_ref26) {
    var req, query, params, data, errorContent, REQUEST_URL, response;
    return regenerator_default.a.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            req = _ref26.req, query = _ref26.query;

            /**
             * 1. Get subdomain params for query
             */
            params = Object(utils_subdomain["b" /* subdomainParamsFromReq */])({
              req: req
            });
            /**
             * 2. Get test / live link request route
             * - extended with query params
             * - e.g. /v1/stripe/checkout/content?sessionId=abc
             */

            data = {};
            errorContent = CHECKOUT_CONTENT_ERROR_CONTENT;

            if (!query.content) {
              _context13.next = 11;
              break;
            }

            REQUEST_URL = checkout_getCheckoutContentAPIRoute({
              pathname: req.url,
              query: {
                subdomain: params.subdomain,
                content: query.content
              }
            });
            /**
             * 3. Render checkout content page summary for live / test context
             * - This is a GET to the provided url
             * - Generate the checkout payload on the server to prevent leaking of Stripe models to the client
             */

            _context13.next = 8;
            return fetchPageResponse(REQUEST_URL);

          case 8:
            data = _context13.sent;
            _context13.next = 13;
            break;

          case 11:
            data = new Error("No content");
            errorContent = CHECKOUT_CONTENT_NO_DATA_CONTENT;

          case 13:
            /**
             * 4. Prepare response shape data
             */
            response = render_preparePageResponse({
              data: data,
              params: params,
              keys: PAGE_KEYS.CHECKOUT.CONTENT,
              errorContent: errorContent
            });
            return _context13.abrupt("return", {
              props: response
            });

          case 15:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));

  return function getCheckoutContentServerSideProps(_x10) {
    return _ref27.apply(this, arguments);
  };
}();
var checkout_getRedirectUrls = function getRedirectUrls(_ref28) {
  var application = _ref28.application,
      merchantAccount = _ref28.merchantAccount;
  var redirectRoot = Object(utils_subdomain["a" /* getSubdomainRoot */])(application.subdomain);
  /**
   * Success URLs - after successful checkout payment
   * 1. Return to the seller configured checkout success url
   * 2. Return to the generic checkout success url
   * - NOTE: if using this url we need to have the application subdomain in the root (i.e. subdomain redirect root)
   * - This allows us to fetch the session on behalf of that account
   */

  var configSuccessURL = get_default()(merchantAccount, "merchant_account_config.data.common.success_url");
  var fallbackSuccessURL = "".concat(redirectRoot).concat(paths["d" /* default */].CHECKOUT_SUCCESS);
  var successUrl = url_defaultHttps(configSuccessURL || fallbackSuccessURL);
  /**
   * Cancel URLs
   * 1. Return to the url of the sellers site within the merchant account
   * 2. Return to the seller configured merchant acccount checkout cancel url
   */

  var merchantRootURL = get_default()(merchantAccount, "profile.url");
  var configCancelURL = get_default()(merchantAccount, "merchant_account_config.data.common.cancel_url");
  var fallbackErrorURL = "".concat(redirectRoot).concat(paths["d" /* default */].CHECKOUT_ERROR);
  var cancelUrl = url_defaultHttps(merchantRootURL || configCancelURL || fallbackErrorURL);
  return {
    successUrl: successUrl,
    cancelUrl: cancelUrl
  };
};
// CONCATENATED MODULE: ./src/components/Nav/hocs.js

var hocs_jsx = react_default.a.createElement;







var getErrorMessage = function getErrorMessage(fragment) {
  return "There was an error creating an authenticated ".concat(fragment, " session.");
};

var hocs_AuthedPricingHOC = function AuthedPricingHOC(WrappedComponent, props) {
  // authedRoutes
  var _useState = Object(react["useState"])(false),
      loading = _useState[0],
      setLoading = _useState[1];

  var _useSelector = Object(es["d" /* useSelector */])(function (state) {
    return Object(mapStateToProps["g" /* getCtxResourceCapabilityAndIDs */])(state);
  }),
      customerId = _useSelector.customerId,
      resourceUUID = _useSelector.resourceUUID,
      resource = _useSelector.resource;

  var _useToasts = Object(dist["useToasts"])(),
      addToast = _useToasts.addToast;

  var setError = function setError() {
    addToast(getErrorMessage("pricing"), {
      appearance: "error",
      autoDismiss: false
    });
  }; // https://stripe.com/docs/api/checkout/sessions/object


  var input = {
    customer: customerId,
    resource: resource,
    resourceUUID: resourceUUID
  };
  var session = checkout_buildCheckoutParams(input);
  return hocs_jsx(WrappedComponent, Object(esm_extends["a" /* default */])({}, props, {
    loading: loading,
    onClick: function onClick() {
      analytics["g" /* default */].track(analytics["d" /* PREPARE_PRICING_SESSION */], input);
      checkout_checkout({
        session: session,
        setLoading: setLoading,
        setError: setError
      })();
    }
  }));
};
var hocs_AuthedBillingHOC = function AuthedBillingHOC(WrappedComponent, props) {
  // authedRoutes
  var _useState2 = Object(react["useState"])(false),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useSelector2 = Object(es["d" /* useSelector */])(function (state) {
    return Object(mapStateToProps["g" /* getCtxResourceCapabilityAndIDs */])(state);
  }),
      customerId = _useSelector2.customerId,
      resourceUUID = _useSelector2.resourceUUID,
      resource = _useSelector2.resource;

  var _useToasts2 = Object(dist["useToasts"])(),
      addToast = _useToasts2.addToast;

  var setError = function setError() {
    addToast(getErrorMessage("billing"), {
      appearance: "error",
      autoDismiss: false
    });
  }; // https://stripe.com/docs/api/customer_portal/create


  var session = buildBillingParams({
    customer: customerId
  });
  return hocs_jsx(WrappedComponent, Object(esm_extends["a" /* default */])({}, props, {
    loading: loading,
    onClick: function onClick() {
      analytics["g" /* default */].track(analytics["c" /* PREPARE_BILLING_SESSION */], {
        customer: customerId,
        resource: resource,
        resourceUUID: resourceUUID
      });
      checkout_billing({
        session: session,
        setLoading: setLoading,
        setError: setError
      })();
    }
  }));
};
// EXTERNAL MODULE: ./node_modules/lodash/kebabCase.js
var kebabCase = __webpack_require__("N1om");
var kebabCase_default = /*#__PURE__*/__webpack_require__.n(kebabCase);

// CONCATENATED MODULE: ./src/components/Icons/account.jsx

var account_jsx = react_default.a.createElement;


function SvgComponent(props) {
  return account_jsx("svg", Object(esm_extends["a" /* default */])({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40"
  }, props), account_jsx("title", null, "navIcon--account"), account_jsx("g", {
    transform: "translate(1 1)",
    fill: "none",
    fillRule: "evenodd"
  }, account_jsx("rect", {
    fill: "#A6C0FF",
    x: 17.882,
    y: 0.48,
    width: 2.235,
    height: 36.568,
    rx: 1.118
  }), account_jsx("rect", {
    fill: "#A6C0FF",
    x: 31.294,
    y: 0.48,
    width: 2.235,
    height: 36.568,
    rx: 1.118
  }), account_jsx("rect", {
    fill: "#A6C0FF",
    x: 4.471,
    y: 0.48,
    width: 2.235,
    height: 36.568,
    rx: 1.118
  }), account_jsx("ellipse", {
    stroke: "#5D8BFF",
    strokeWidth: 2,
    fill: "#FFF",
    cx: 19,
    cy: 23.886,
    rx: 4.588,
    ry: 4.429
  }), account_jsx("ellipse", {
    stroke: "#5D8BFF",
    strokeWidth: 2,
    fill: "#FFF",
    cx: 32.412,
    cy: 14.114,
    rx: 4.588,
    ry: 4.429
  }), account_jsx("ellipse", {
    stroke: "#5D8BFF",
    strokeWidth: 2,
    fill: "#FFF",
    cx: 5.588,
    cy: 10.857,
    rx: 4.588,
    ry: 4.429
  })));
}

/* harmony default export */ var account = (SvgComponent);
// CONCATENATED MODULE: ./src/components/Icons/plans.jsx

var plans_jsx = react_default.a.createElement;


function plans_SvgComponent(props) {
  return plans_jsx("svg", Object(esm_extends["a" /* default */])({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40"
  }, props), plans_jsx("title", null, "navIcon--plan"), plans_jsx("g", {
    fill: "#5D8BFF",
    fillRule: "nonzero"
  }, plans_jsx("path", {
    d: "M3.137 34.6h6.825c.629 0 1.138-.56 1.138-1.25v-12.5c0-.69-.51-1.25-1.138-1.25H3.137C2.51 19.6 2 20.16 2 20.85v12.5c0 .69.51 1.25 1.137 1.25zm1.138-12.733h4.55v11h-4.55v-11zM29.137 13.8c-.628 0-1.137.582-1.137 1.3v18.2c0 .718.51 1.3 1.137 1.3h6.825c.629 0 1.138-.582 1.138-1.3V15.1c0-.718-.51-1.3-1.138-1.3h-6.825zM34.825 32h-4.55V16.4h4.55V32z",
    fillOpacity: 0.551
  }), plans_jsx("path", {
    d: "M22.962 6h-6.825C15.51 6 15 6.64 15 7.43v25.74c0 .79.51 1.43 1.137 1.43h6.825c.629 0 1.138-.64 1.138-1.43V7.43c0-.79-.51-1.43-1.138-1.43zm-1.137 25.22h-4.55V9.12h4.55v22.1z"
  })));
}

/* harmony default export */ var plans = (plans_SvgComponent);
// CONCATENATED MODULE: ./src/components/Icons/billing.jsx

var billing_jsx = react_default.a.createElement;


function billing_SvgComponent(props) {
  return billing_jsx("svg", Object(esm_extends["a" /* default */])({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40"
  }, props), billing_jsx("title", null, "navIcon--billing"), billing_jsx("g", {
    fill: "none",
    fillRule: "evenodd"
  }, billing_jsx("path", {
    d: "M32.84 2.176H7.364a.977.977 0 00-.968.968v33.968c0 .729.591 1.32 1.32 1.32h24.816a1.32 1.32 0 001.32-1.32V3.144c0-.528-.44-.968-1.012-.968zM7.826 36.98V3.54h24.64l-.046 33.44H7.826z",
    fill: "#A6C0FF",
    fillRule: "nonzero"
  }), billing_jsx("g", {
    fill: "#5D8BFF"
  }, billing_jsx("path", {
    fillRule: "nonzero",
    d: "M20.124 15.86h-9.812v1.98h9.812z"
  }), billing_jsx("path", {
    d: "M10.312 19.776v1.98h19.58v-1.98h.044zM23.952 27.652h-13.64v1.98h13.64zM26.152 23.692h-15.84v1.98h15.84zM12.292 6.664h-1.98v6.6h1.98zM26.02 6.664h-1.98v6.6h1.98zM22.06 6.664h-1.98v6.6h1.98zM29.936 6.664h-1.98v6.6h1.98zM18.144 6.664h-3.916v6.6h3.916z"
  }))));
}

/* harmony default export */ var Icons_billing = (billing_SvgComponent);
// CONCATENATED MODULE: ./src/components/Icons/code.jsx

var code_jsx = react_default.a.createElement;


function code_SvgComponent(props) {
  return code_jsx("svg", Object(esm_extends["a" /* default */])({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40"
  }, props), code_jsx("title", null, "navIcon--code"), code_jsx("g", {
    fill: "none",
    fillRule: "evenodd"
  }, code_jsx("path", {
    d: "M30.44 14.56a1.5 1.5 0 012.12-2.12l6 6a1.5 1.5 0 010 2.12l-6 6a1.5 1.5 0 01-2.12-2.12l4.939-4.94-4.94-4.94zM4.621 19.5l4.94 4.94a1.5 1.5 0 01-2.122 2.12l-6-6a1.5 1.5 0 010-2.12l6-6a1.5 1.5 0 012.122 2.12L4.62 19.5z",
    fill: "#5D8BFF"
  }), code_jsx("path", {
    d: "M23.696 9.418a1.5 1.5 0 112.809 1.054l-9.58 20.038a1.5 1.5 0 11-2.808-1.054l9.58-20.038z",
    fill: "#A6C0FF"
  })));
}

/* harmony default export */ var code = (code_SvgComponent);
// CONCATENATED MODULE: ./src/components/Icons/profile.jsx

var profile_jsx = react_default.a.createElement;


function profile_SvgComponent(props) {
  return profile_jsx("svg", Object(esm_extends["a" /* default */])({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40"
  }, props), profile_jsx("title", null, "navIcon--profile"), profile_jsx("g", {
    fill: "none",
    fillRule: "evenodd"
  }, profile_jsx("path", {
    d: "M10 33.411v-5.704s.738-2.816 2.908-2.816h15.074s2.745.004 2.745 2.772v5.82",
    stroke: "#5D8BFF",
    strokeWidth: 2.64
  }), profile_jsx("g", {
    transform: "translate(12.4 7.327)"
  }, profile_jsx("ellipse", {
    fill: "#5D8BFF",
    cx: 7.964,
    cy: 7.336,
    rx: 7.434,
    ry: 7.336
  }), profile_jsx("ellipse", {
    fill: "#FFF",
    cx: 7.964,
    cy: 7.336,
    rx: 5.002,
    ry: 4.936
  }))));
}

/* harmony default export */ var profile = (profile_SvgComponent);
// CONCATENATED MODULE: ./src/components/Icons/analytics.jsx

var analytics_jsx = react_default.a.createElement;


function analytics_SvgComponent(props) {
  return analytics_jsx("svg", Object(esm_extends["a" /* default */])({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), analytics_jsx("title", null, "navIcon--analytics"), analytics_jsx("g", {
    fill: "none",
    fillRule: "evenodd"
  }, analytics_jsx("path", {
    fill: "#A6C0FF",
    d: "M2 33h36v2H2z"
  }), analytics_jsx("path", {
    d: "M6.875 30h5.25c.483 0 .875-.298.875-.667v-6.666c0-.369-.392-.667-.875-.667h-5.25c-.483 0-.875.298-.875.667v6.666c0 .369.392.667.875.667zm.875-6.667h3.5v5.334h-3.5v-5.334zM16.875 14c-.483 0-.875.448-.875 1v14c0 .552.392 1 .875 1h5.25c.483 0 .875-.448.875-1V15c0-.552-.392-1-.875-1h-5.25zm4.375 14h-3.5V16h3.5v12z",
    fill: "#A6C0FF",
    fillRule: "nonzero"
  }), analytics_jsx("path", {
    d: "M32.125 4h-5.25C26.392 4 26 4.582 26 5.3v23.4c0 .718.392 1.3.875 1.3h5.25c.483 0 .875-.582.875-1.3V5.3c0-.718-.392-1.3-.875-1.3zm-.875 23.4h-3.5V6.6h3.5v20.8z",
    fill: "#5D8BFF",
    fillRule: "nonzero"
  })));
}

/* harmony default export */ var Icons_analytics = (analytics_SvgComponent);
// CONCATENATED MODULE: ./src/components/Icons/sales.jsx

var sales_jsx = react_default.a.createElement;


function sales_SvgComponent(props) {
  return sales_jsx("svg", Object(esm_extends["a" /* default */])({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), sales_jsx("title", null, "navIcon--dollar"), sales_jsx("g", {
    fill: "none",
    fillRule: "evenodd"
  }, sales_jsx("path", {
    d: "M20.924 29.3v-1.887c1.11-.22 1.968-.736 2.571-1.546.603-.81.905-1.78.905-2.913 0-.818-.226-1.526-.679-2.123-.452-.598-1.67-1.345-3.654-2.241-1.016-.456-1.524-1.03-1.524-1.723 0-.55.19-.998.571-1.344.381-.346.857-.52 1.429-.52.905 0 1.69.41 2.357 1.228l1.048-1.51c-.778-.96-1.786-1.502-3.024-1.628V11.3h-1.405v1.77c-1.032.188-1.841.644-2.429 1.368-.587.723-.88 1.62-.88 2.689 0 1.463.912 2.619 2.738 3.468.952.44 1.635.759 2.047.955.413.197.69.429.834.696.142.268.214.574.214.92 0 1.542-.746 2.312-2.238 2.312-1.127 0-2.08-.747-2.857-2.24L15.4 24.7c.952 1.683 2.325 2.618 4.119 2.807V29.3h1.405z",
    fill: "#5D8BFF",
    fillRule: "nonzero"
  }), sales_jsx("path", {
    stroke: "#5D8BFF",
    strokeWidth: 2,
    d: "M4 7.5h32v25H4z"
  })));
}

/* harmony default export */ var sales = (sales_SvgComponent);
// CONCATENATED MODULE: ./src/components/Icons/pages.jsx

var pages_jsx = react_default.a.createElement;


function pages_SvgComponent(props) {
  return pages_jsx("svg", Object(esm_extends["a" /* default */])({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), pages_jsx("title", null, "navIcon--pages"), pages_jsx("path", {
    d: "M8.265 36.96C7.011 36.96 6 35.962 6 34.725V4.235C6 2.998 7.011 2 8.265 2h24.47C33.989 2 35 2.998 35 4.235v21.87c0 .24-.08.479-.283.678l-10.678 9.978c-.162.12-.364.239-.607.239H8.265v-.04zm16.098-2.993l7.482-6.984h-7.482v6.984zm8.817-8.74V4.235c0-.28-.162-.44-.445-.44H8.265c-.283 0-.445.16-.445.44v30.49c0 .28.162.44.445.44h14.278v-9.06c0-.479.404-.878.89-.878h9.747z",
    fill: "#5D8BFF",
    fillRule: "nonzero"
  }));
}

/* harmony default export */ var pages = (pages_SvgComponent);
// CONCATENATED MODULE: ./src/components/Icons/products.jsx

var products_jsx = react_default.a.createElement;


function products_SvgComponent(props) {
  return products_jsx("svg", Object(esm_extends["a" /* default */])({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), products_jsx("title", null, "navIcon--products"), products_jsx("path", {
    d: "M34.851 4h.006C35.488 4 36 4.512 36 5.143v.006l-.067 13.781a1.136 1.136 0 01-.335.802L19.665 35.665a1.14 1.14 0 01-1.616 0L4.335 21.951a1.14 1.14 0 010-1.616L20.267 4.402c.206-.206.49-.334.803-.335L34.851 4zm-1.142 2.291l-12.158.059L6.76 21.143l12.098 12.098 14.793-14.793.059-12.157h-.001zm-6.852 4.566a2.304 2.304 0 012.286 2.286 2.304 2.304 0 01-2.286 2.286 2.304 2.304 0 01-2.286-2.286 2.304 2.304 0 012.286-2.286z",
    fill: "#5D8BFF",
    fillRule: "nonzero"
  }));
}

/* harmony default export */ var products = (products_SvgComponent);
// CONCATENATED MODULE: ./src/components/Icons/coupons.jsx

var coupons_jsx = react_default.a.createElement;


function coupons_SvgComponent(props) {
  return coupons_jsx("svg", Object(esm_extends["a" /* default */])({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), coupons_jsx("title", null, "navIcon--coupons"), coupons_jsx("g", {
    fill: "none",
    fillRule: "evenodd"
  }, coupons_jsx("circle", {
    fill: "#A6C0FF",
    cx: 13,
    cy: 9,
    r: 2
  }), coupons_jsx("circle", {
    fill: "#A6C0FF",
    cx: 13,
    cy: 14.4,
    r: 2
  }), coupons_jsx("circle", {
    fill: "#A6C0FF",
    cx: 13,
    cy: 20.3,
    r: 2
  }), coupons_jsx("circle", {
    fill: "#A6C0FF",
    cx: 13,
    cy: 26.1,
    r: 2
  }), coupons_jsx("circle", {
    fill: "#A6C0FF",
    cx: 13,
    cy: 32,
    r: 2
  }), coupons_jsx("path", {
    d: "M38 24.047h-1.253c-2.026 0-3.684-1.588-3.684-3.53 0-1.94 1.658-3.529 3.684-3.529H38V7H3v27h35v-9.953zM5.505 31.6V9.435h29.99v5.26c-2.837.564-4.974 2.964-4.974 5.823 0 2.858 2.137 5.258 4.974 5.823V31.6H5.505z",
    fill: "#5D8BFF",
    fillRule: "nonzero"
  })));
}

/* harmony default export */ var coupons = (coupons_SvgComponent);
// CONCATENATED MODULE: ./src/components/Icons/settings.jsx

var settings_jsx = react_default.a.createElement;


function settings_SvgComponent(props) {
  return settings_jsx("svg", Object(esm_extends["a" /* default */])({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), settings_jsx("title", null, "navIcon--settings"), settings_jsx("g", {
    fill: "none",
    fillRule: "evenodd"
  }, settings_jsx("path", {
    d: "M6.309 22.899a1.923 1.923 0 00-.536 2.553l2.78 4.7c.237.402.61.71 1.055.867.488.16 1.022.11 1.471-.137l2.504-1.123c.435.285.889.543 1.357.772l.257 2.739A1.978 1.978 0 0017.132 35h5.54c1.02.003 1.87-.768 1.948-1.768l.25-2.698c.474-.227.93-.487 1.368-.775l2.53 1.146.06.025a2.005 2.005 0 002.456-.82l2.747-4.648a1.923 1.923 0 00-.52-2.554l-2.113-1.583a7.64 7.64 0 000-1.618l2.273-1.596.026-.02a1.926 1.926 0 00.529-2.553l-2.841-4.683a1.894 1.894 0 00-2.543-.734l-2.49 1.124a12.623 12.623 0 00-1.361-.773l-.254-2.739a1.225 1.225 0 00-.02-.137A1.978 1.978 0 0022.8 6h-5.537c-1.02-.003-1.87.768-1.948 1.768l-.25 2.707c-.473.226-.93.483-1.367.77l-2.524-1.14-.061-.026a2.005 2.005 0 00-2.455.82L5.91 15.542a1.929 1.929 0 00.526 2.554l.026.019 2.273 1.596a7.64 7.64 0 00-.043.795c0 .28 0 .533.04.775L6.36 22.864l-.052.035zm4.546.05c.412-.274.628-.756.555-1.24a8.216 8.216 0 01-.126-1.207 8.25 8.25 0 01.117-1.213 1.267 1.267 0 00-.533-1.223l-2.442-1.714 2.189-3.703 2.689 1.216c.451.205.982.138 1.367-.172a8.898 8.898 0 012.136-1.207c.439-.184.74-.59.783-1.056l.266-2.89h4.348l.267 2.89c.039.469.337.878.776 1.066.775.325 1.507.742 2.179 1.242.381.28.889.333 1.321.137l2.696-1.22 2.247 3.697-2.436 1.701c-.396.278-.602.75-.532 1.223.069.4.108.806.117 1.213a8.253 8.253 0 01-.117 1.213c-.067.458.125.917.5 1.197l2.29 1.714-2.193 3.732-2.688-1.217a1.317 1.317 0 00-1.368.173 8.908 8.908 0 01-2.136 1.206c-.439.185-.74.59-.783 1.057l-.266 2.889h-4.352l-.266-2.89a1.279 1.279 0 00-.782-1.056 10.345 10.345 0 01-2.18-1.241 1.318 1.318 0 00-1.318-.138l-2.689 1.217L8.31 24.65l2.546-1.701z",
    fill: "#5D8BFF",
    fillRule: "nonzero"
  }), settings_jsx("path", {
    d: "M6.309 22.899a1.923 1.923 0 00-.536 2.554l2.78 4.698c.237.403.61.71 1.055.868.488.16 1.022.11 1.471-.137l2.504-1.123c.435.285.889.543 1.357.772l.257 2.739A1.978 1.978 0 0017.132 35h5.54c1.02.003 1.87-.768 1.948-1.768l.25-2.698c.474-.227.93-.487 1.368-.775l2.53 1.146.06.025a2.005 2.005 0 002.456-.82l2.747-4.648a1.923 1.923 0 00-.52-2.554l-2.113-1.583a7.64 7.64 0 000-1.618l2.273-1.596.026-.02a1.926 1.926 0 00.529-2.553l-2.841-4.683a1.894 1.894 0 00-2.543-.734l-2.49 1.124a12.623 12.623 0 00-1.361-.773l-.254-2.739a1.225 1.225 0 00-.02-.137A1.978 1.978 0 0022.8 6h-5.537c-1.02-.003-1.87.768-1.948 1.768l-.25 2.707c-.473.226-.93.483-1.367.77l-2.524-1.14-.061-.026a2.005 2.005 0 00-2.455.82L5.91 15.542a1.929 1.929 0 00.526 2.554l.026.019 2.273 1.596a7.64 7.64 0 00-.043.795c0 .28 0 .533.04.775L6.36 22.864l-.052.035z"
  }), settings_jsx("path", {
    d: "M11.004 23.462c.406-.276.618-.76.547-1.246-.071-.4-.113-.805-.125-1.211.009-.408.047-.815.115-1.218a1.283 1.283 0 00-.524-1.227l-2.402-1.72 2.153-3.717 2.645 1.221c.444.205.967.138 1.345-.173a8.708 8.708 0 012.102-1.211c.431-.185.727-.592.77-1.06l.262-2.9h4.277l.262 2.9c.039.47.332.881.763 1.07a10.12 10.12 0 012.144 1.246c.375.282.874.334 1.3.138l2.651-1.224 2.211 3.71-2.396 1.707c-.39.279-.592.752-.524 1.228.068.402.106.809.115 1.217a8.447 8.447 0 01-.115 1.217c-.065.46.123.92.492 1.202l2.252 1.72-2.156 3.746-2.645-1.221a1.275 1.275 0 00-1.345.173c-.64.5-1.348.907-2.102 1.211a1.281 1.281 0 00-.77 1.06l-.262 2.9h-4.28l-.262-2.9a1.281 1.281 0 00-.77-1.06 10.126 10.126 0 01-2.143-1.246 1.275 1.275 0 00-1.297-.138l-2.645 1.22L8.5 25.17l2.504-1.708z"
  }), settings_jsx("path", {
    d: "M20 26a5.5 5.5 0 10-5.5-5.5A5.442 5.442 0 0020 26zm0-8.439a2.939 2.939 0 11-2.939 2.939 2.907 2.907 0 012.94-2.939z",
    fill: "#5D8BFF",
    fillRule: "nonzero"
  })));
}

/* harmony default export */ var settings = (settings_SvgComponent);
// CONCATENATED MODULE: ./src/components/Icons/home.jsx

var home_jsx = react_default.a.createElement;


function home_SvgComponent(props) {
  return home_jsx("svg", Object(esm_extends["a" /* default */])({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), home_jsx("title", null, "navIcon--house"), home_jsx("path", {
    d: "M30.318 35h-8.016V24.448h-3.604V35h-8.016C8.652 35 7 33.417 7 31.47V16.04L20.5 4 34 16.04v15.43c0 1.947-1.652 3.53-3.682 3.53zm-5.254-2.647h5.254c.508 0 .92-.396.92-.882V17.193L20.5 7.616 9.761 17.193V31.47c0 .487.413.882.92.882h5.255V21.801h9.128v10.552z",
    fill: "#5D8BFF",
    fillRule: "nonzero"
  }));
}

/* harmony default export */ var home = (home_SvgComponent);
// CONCATENATED MODULE: ./src/components/Icons/links.jsx

var links_jsx = react_default.a.createElement;


function links_SvgComponent(props) {
  return links_jsx("svg", Object(esm_extends["a" /* default */])({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), links_jsx("title", null, "navIcon--links"), links_jsx("path", {
    d: "M6.76 23.34c-2.835 2.836-2.923 7.367-.195 10.095 2.728 2.728 7.26 2.64 10.095-.196l5.717-5.717c2.836-2.835 2.924-7.367.196-10.095a1.159 1.159 0 00-1.15-.299 1.254 1.254 0 00-.864.865c-.118.417-.003.856.299 1.15 1.842 1.842 1.784 4.814-.13 6.73l-5.718 5.716c-1.915 1.916-4.888 1.973-6.73.13-1.842-1.841-1.785-4.814.13-6.729l5.432-5.431c.313-.305.445-.75.344-1.162a1.129 1.129 0 00-.832-.832 1.224 1.224 0 00-1.162.344L6.76 23.34zm10.863-10.862c-2.836 2.835-2.924 7.367-.196 10.095.293.302.733.416 1.15.299.417-.118.747-.448.864-.865a1.158 1.158 0 00-.299-1.15c-1.842-1.842-1.784-4.814.13-6.73l5.718-5.716c1.915-1.916 4.888-1.973 6.73-.13 1.842 1.841 1.785 4.814-.13 6.729l-5.432 5.431a1.223 1.223 0 00-.344 1.162c.102.413.42.73.832.832.413.1.857-.03 1.162-.344l5.431-5.431c2.836-2.836 2.924-7.367.196-10.095-2.728-2.728-7.26-2.64-10.095.196l-5.717 5.717z",
    fill: "#5D8BFF",
    fillRule: "nonzero"
  }));
}

/* harmony default export */ var links = (links_SvgComponent);
// CONCATENATED MODULE: ./src/components/Icons/channels.jsx

var channels_jsx = react_default.a.createElement;


var channels_Channels = function Channels(props) {
  return channels_jsx("svg", Object(esm_extends["a" /* default */])({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), channels_jsx("title", null, "navIcon--channels"), channels_jsx("g", {
    fill: "none",
    fillRule: "evenodd"
  }, channels_jsx("g", {
    transform: "rotate(90 8.116 30.08)"
  }, channels_jsx("path", {
    d: "M7.203 0c3.978 0 7.202 3.198 7.202 7.143 0 3.455-2.474 6.338-5.761 7V20H5.761v-5.857C2.476 13.48 0 10.599 0 7.143 0 3.198 3.225 0 7.203 0z",
    fill: "#A6C0FF"
  }), channels_jsx("ellipse", {
    fill: "#FFF",
    cx: 7.203,
    cy: 7.143,
    rx: 4.322,
    ry: 4.286
  })), channels_jsx("g", {
    transform: "rotate(-146 11.643 17.915)"
  }, channels_jsx("path", {
    d: "M7.61.18c3.978 0 7.203 3.197 7.203 7.142 0 3.456-2.474 6.338-5.762 7v5.857H6.17v-5.857c-3.288-.661-5.763-3.544-5.763-7C.407 3.377 3.632.18 7.61.18z",
    fill: "#A6C0FF"
  }), channels_jsx("ellipse", {
    fill: "#FFF",
    cx: 7.61,
    cy: 7.322,
    rx: 4.322,
    ry: 4.286
  })), channels_jsx("g", {
    transform: "rotate(-30 19.65 -15.354)"
  }, channels_jsx("path", {
    d: "M7.203 0c3.978 0 7.202 3.198 7.202 7.143 0 3.455-2.474 6.338-5.761 7V20H5.761v-5.857C2.476 13.48 0 10.599 0 7.143 0 3.198 3.225 0 7.203 0z",
    fill: "#5D8BFF"
  }), channels_jsx("ellipse", {
    fill: "#FFF",
    cx: 7.203,
    cy: 7.143,
    rx: 4.322,
    ry: 4.286
  }))));
};

/* harmony default export */ var channels = (channels_Channels);
// CONCATENATED MODULE: ./src/components/Icons/taxRates.jsx

var taxRates_jsx = react_default.a.createElement;


function taxRates_SvgComponent(props) {
  return taxRates_jsx("svg", Object(esm_extends["a" /* default */])({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), taxRates_jsx("title", null, "navIcon--taxRates"), taxRates_jsx("g", {
    transform: "translate(8.5 8)",
    stroke: "#5D8BFF",
    strokeWidth: 2.4,
    fill: "none",
    fillRule: "evenodd"
  }, taxRates_jsx("path", {
    d: "M.36 22.8L23.16 0"
  }), taxRates_jsx("circle", {
    cx: 4.8,
    cy: 5.64,
    r: 3.6
  }), taxRates_jsx("circle", {
    cx: 17.64,
    cy: 18.36,
    r: 3.6
  })));
}

/* harmony default export */ var taxRates = (taxRates_SvgComponent);
// CONCATENATED MODULE: ./src/components/Icons/files.jsx

var files_jsx = react_default.a.createElement;


var files_Files = function Files(props) {
  return files_jsx("svg", Object(esm_extends["a" /* default */])({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), files_jsx("title", null, "navIcon--files"), files_jsx("g", {
    id: "navIcon--files",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, files_jsx("g", {
    id: "Group",
    transform: "translate(1.000000, 4.000000)",
    fillRule: "nonzero"
  }, files_jsx("path", {
    d: "M25.0037823,21.6767618 L19.9622894,16.7870741 C19.5694939,16.4043091 18.9302749,16.4043091 18.5374794,16.7870741 L13.4959865,21.6767618 C13.1013382,22.0595267 13.1013382,22.6777011 13.4959865,23.0586691 C13.6923842,23.249153 13.9499247,23.344395 14.2093179,23.344395 C14.4668583,23.344395 14.7262516,23.249153 14.9226493,23.0586691 L18.2428828,19.8384117 L18.2428828,30.9224226 C18.2428828,31.4615281 18.6949682,31.9000007 19.2508108,31.9000007 C19.8066535,31.9000007 20.2587388,31.4615281 20.2587388,30.9224226 L20.2587388,19.8384117 L23.5789723,23.0586691 C23.77537,23.249153 24.0329105,23.344395 24.2923037,23.344395 C24.5498442,23.344395 24.8092374,23.249153 25.0056351,23.0586691 C25.3984306,22.6777011 25.3984306,22.0577297 25.0037823,21.6767618 Z",
    id: "Path",
    fill: "#A6C0FF"
  }), files_jsx("path", {
    d: "M29.7776978,10.2392624 C29.2909702,4.5112655 24.5072924,0 18.7000004,0 C12.5694618,0 7.58143271,5.02603646 7.58143271,11.203288 C7.58143271,11.7143151 7.61858749,12.2272142 7.69103931,12.7401133 C7.57028628,12.7344976 7.44953324,12.7307538 7.32878021,12.7307538 C3.28819797,12.7307538 0,16.0440069 0,20.1153772 C0,24.1867475 3.28819797,27.5 7.32878021,27.5 L11.4469504,27.5 C12.0061298,27.5 12.4575604,27.0432584 12.4575604,26.48169 C12.4575604,25.9201217 12.0042721,25.4633795 11.4469504,25.4633795 L7.32878021,25.4633795 C4.40284134,25.4633795 2.02121999,23.0654828 2.02121999,20.1153772 C2.02121999,17.1652716 4.4009836,14.7673749 7.32878021,14.7673749 C7.78392626,14.7673749 8.25021874,14.8328912 8.71651122,14.96018 C9.06762388,15.0556466 9.44288715,14.9545643 9.69925513,14.6924991 C9.9556231,14.4323058 10.0522255,14.0523112 9.95376537,13.6985232 C9.71969026,12.8674021 9.6026527,12.0269215 9.6026527,11.2014161 C9.6026527,6.1473012 13.6841052,2.03474921 18.7000004,2.03474921 C23.7158956,2.03474921 27.7973481,6.1473012 27.7973481,11.2014161 C27.7973481,11.7648563 28.2506364,12.2197266 28.8079581,12.2197266 C32.4305491,12.2197266 35.3787808,15.190423 35.3787808,18.8406171 C35.3787808,22.4908112 32.4324068,25.4615076 28.8079581,25.4615076 L27.0530505,25.4615076 C26.493871,25.4615076 26.0424405,25.9182498 26.0424405,26.4798181 C26.0424405,27.0432584 26.4957288,27.4981287 27.0530505,27.4981287 L28.8079581,27.4981287 C33.5451925,27.4981287 37.4000008,23.6139478 37.4000008,18.8406171 C37.4000008,14.3986117 34.0616439,10.7259549 29.7776978,10.2392624 Z",
    id: "Path",
    fill: "#5D8BFF"
  }))));
};

/* harmony default export */ var files = (files_Files);
// CONCATENATED MODULE: ./src/components/Icons/tutorial.jsx

var tutorial_jsx = react_default.a.createElement;


var tutorial_Tutorial = function Tutorial(props) {
  return tutorial_jsx("svg", Object(esm_extends["a" /* default */])({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), tutorial_jsx("title", null, "navIcon--tutorials"), tutorial_jsx("path", {
    d: "M37.38 14.314L20.24 7.068a.85.85 0 00-.667 0L2.43 14.314a.863.863 0 00-.004 1.591l6.432 2.72a.907.907 0 00-.064.324v8.854a.86.86 0 00.529.796l10.247 4.332a.833.833 0 00.667 0l10.246-4.332a.863.863 0 00.525-.796v-8.85a.808.808 0 00-.064-.324l2.829-1.198v10.623c0 .476.387.865.86.865s.86-.39.86-.865V17.008c0-.1-.022-.195-.052-.286l1.935-.817a.863.863 0 00.525-.795.853.853 0 00-.52-.796zM19.904 8.802L34.83 15.11l-14.926 6.312L4.98 15.11l14.925-6.308zm9.392 18.43l-9.392 3.97-9.387-3.97V19.33l9.056 3.83c.108.044.22.07.336.07a.818.818 0 00.335-.07l9.056-3.83v7.904h-.004z",
    fill: "#5D8BFF",
    fillRule: "nonzero"
  }));
};

/* harmony default export */ var tutorial = (tutorial_Tutorial);
// CONCATENATED MODULE: ./src/components/Icons/learn.jsx

var learn_jsx = react_default.a.createElement;


var learn_Learn = function Learn(props) {
  return learn_jsx("svg", Object(esm_extends["a" /* default */])({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), learn_jsx("title", null, "navIcon--Learn"), learn_jsx("path", {
    d: "M35.6 9.499H34V7.042 6.96v-.082c0-.04 0-.04-.04-.082 0-.04 0-.04-.04-.081 0 0-.04-.041-.04-.082s-.04-.041-.04-.082l-.04-.041-.04-.041-.04-.041s-.04-.041-.08-.041-.04-.04-.08-.04-.04-.042-.08-.042h-.08c-.04 0-.04 0-.08-.04-4.64-.779-9.48.327-13.32 3.029a17.722 17.722 0 00-13.32-3.03c-.04 0-.08 0-.08.041h-.08c-.04 0-.04.041-.08.041s-.04 0-.08.041c-.04 0-.04.04-.04.04-.04 0-.04.042-.08.042l-.04.04-.04.042s-.04.04-.04.082c0 .04-.04.04-.04.082 0 .04 0 .04-.04.081 0 .041 0 .041-.04.082V9.5H4.4c-1.32 0-2.4 1.105-2.4 2.415v18.67A2.4 2.4 0 004.4 33h31.2c1.32 0 2.4-1.105 2.4-2.416V11.955c0-1.35-1.08-2.456-2.4-2.456zM4.4 31.403c-.44 0-.8-.368-.8-.819V11.955c0-.45.36-.819.8-.819H6v17.852c0 .245.12.45.28.614.16.163.4.204.64.163 3.52-.573 7.12 0 10.28 1.638H4.4zm14.8-.696a18.068 18.068 0 00-11.6-2.661V7.779c4.08-.532 8.24.532 11.6 2.948v19.98zm1.6-19.98c3.36-2.416 7.52-3.48 11.6-2.948v20.267c-4.04-.45-8.16.491-11.6 2.661v-19.98zm15.6 19.898c0 .45-.36.82-.8.82H22.8c3.12-1.639 6.76-2.212 10.28-1.639.24.041.48-.04.64-.163.2-.164.28-.369.28-.614V11.136h1.6c.44 0 .8.369.8.82v18.67z",
    fill: "#5D8BFF",
    fillRule: "nonzero"
  }));
};

/* harmony default export */ var learn = (learn_Learn);
// CONCATENATED MODULE: ./src/components/Icons/docs.jsx

var docs_jsx = react_default.a.createElement;


var docs_Docs = function Docs(props) {
  return docs_jsx("svg", Object(esm_extends["a" /* default */])({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), docs_jsx("title", null, "navIcon--docs"), docs_jsx("path", {
    d: "M35.6 9.499H34V7.042 6.96v-.082c0-.04 0-.04-.04-.082 0-.04 0-.04-.04-.081 0 0-.04-.041-.04-.082s-.04-.041-.04-.082l-.04-.041-.04-.041-.04-.041s-.04-.041-.08-.041-.04-.04-.08-.04-.04-.042-.08-.042h-.08c-.04 0-.04 0-.08-.04-4.64-.779-9.48.327-13.32 3.029a17.722 17.722 0 00-13.32-3.03c-.04 0-.08 0-.08.041h-.08c-.04 0-.04.041-.08.041s-.04 0-.08.041c-.04 0-.04.04-.04.04-.04 0-.04.042-.08.042l-.04.04-.04.042s-.04.04-.04.082c0 .04-.04.04-.04.082 0 .04 0 .04-.04.081 0 .041 0 .041-.04.082V9.5H4.4c-1.32 0-2.4 1.105-2.4 2.415v18.67A2.4 2.4 0 004.4 33h31.2c1.32 0 2.4-1.105 2.4-2.416V11.955c0-1.35-1.08-2.456-2.4-2.456zM4.4 31.403c-.44 0-.8-.368-.8-.819V11.955c0-.45.36-.819.8-.819H6v17.852c0 .245.12.45.28.614.16.163.4.204.64.163 3.52-.573 7.12 0 10.28 1.638H4.4zm14.8-.696a18.068 18.068 0 00-11.6-2.661V7.779c4.08-.532 8.24.532 11.6 2.948v19.98zm1.6-19.98c3.36-2.416 7.52-3.48 11.6-2.948v20.267c-4.04-.45-8.16.491-11.6 2.661v-19.98zm15.6 19.898c0 .45-.36.82-.8.82H22.8c3.12-1.639 6.76-2.212 10.28-1.639.24.041.48-.04.64-.163.2-.164.28-.369.28-.614V11.136h1.6c.44 0 .8.369.8.82v18.67z",
    fill: "#5D8BFF",
    fillRule: "nonzero"
  }));
};

/* harmony default export */ var docs = (docs_Docs);
// CONCATENATED MODULE: ./src/components/Icons/campaigns.jsx

var campaigns_jsx = react_default.a.createElement;


var campaigns_Campaigns = function Campaigns(props) {
  return campaigns_jsx("svg", Object(esm_extends["a" /* default */])({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), campaigns_jsx("title", null, "navIcon--campaigns"), campaigns_jsx("path", {
    d: "M10.236 25.857l9.16 1.923c0 1.922-2.63 5.23-6.094 3.8-2.31-.954-3.331-2.862-3.066-5.723h0zM36.964 8.735A1 1 0 0137 9v21.44a1 1 0 01-1.218.976l-32-7.144A1 1 0 013 23.296v-5.493a1 1 0 01.735-.964l32-8.803a1 1 0 011.23.699z",
    stroke: "#5D8BFF",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  }));
};

/* harmony default export */ var campaigns = (campaigns_Campaigns);
// CONCATENATED MODULE: ./src/components/Nav/config.js


function config_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function config_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { config_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { config_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
























var DEFAULT_STYLE = {
  highlight: true
};
var ROUTE_DEFAULTS = {
  style: DEFAULT_STYLE
};
/**
 * ================
 * Authed
 * ================
 */

var AUTHED_PROFILE = config_objectSpread(config_objectSpread({}, ROUTE_DEFAULTS), {}, {
  href: paths["d" /* default */].PROFILE,
  title: "Profile",
  icon: profile,
  description: ["Your profile and account information"]
});
var config_AUTHED_HOME = function AUTHED_HOME(_ref) {
  var href = _ref.href;
  return config_objectSpread(config_objectSpread({}, ROUTE_DEFAULTS), {}, {
    href: href,
    title: "Home",
    icon: home,
    description: ["Overview of your PriceBlocs app."]
  });
};
var config_AUTHED_SALES = function AUTHED_SALES(_ref2) {
  var href = _ref2.href;
  return config_objectSpread(config_objectSpread({}, ROUTE_DEFAULTS), {}, {
    href: href,
    title: "Sales",
    icon: sales,
    description: ["Your sales from pages and links."]
  });
};
var config_AUTHED_LINKS = function AUTHED_LINKS(_ref3) {
  var href = _ref3.href;
  return config_objectSpread(config_objectSpread({}, ROUTE_DEFAULTS), {}, {
    href: href,
    title: "Links",
    icon: links,
    description: ["Your one click checkout payment links."]
  });
};
var config_AUTHED_PAGES = function AUTHED_PAGES(_ref4) {
  var href = _ref4.href;
  return config_objectSpread(config_objectSpread({}, ROUTE_DEFAULTS), {}, {
    href: href,
    title: "Pages",
    icon: pages,
    description: ["Your hosted pricing pages."]
  });
};
var config_AUTHED_PRODUCTS = function AUTHED_PRODUCTS(_ref5) {
  var href = _ref5.href;
  return config_objectSpread(config_objectSpread({}, ROUTE_DEFAULTS), {}, {
    href: href,
    title: "Products",
    icon: products,
    description: ["Your products for sale."]
  });
};
var config_AUTHED_COUPONS = function AUTHED_COUPONS(_ref6) {
  var href = _ref6.href;
  return config_objectSpread(config_objectSpread({}, ROUTE_DEFAULTS), {}, {
    href: href,
    title: "Coupons",
    icon: coupons,
    description: ["Your coupons for applying discounts."]
  });
};
var config_AUTHED_ANALYTICS = function AUTHED_ANALYTICS(_ref7) {
  var href = _ref7.href;
  return config_objectSpread(config_objectSpread({}, ROUTE_DEFAULTS), {}, {
    href: href,
    title: "Analytics",
    icon: Icons_analytics,
    description: ["Metrics for your pages and links."]
  });
};
var config_AUTHED_TAX_RATES = function AUTHED_TAX_RATES(_ref8) {
  var href = _ref8.href;
  return config_objectSpread(config_objectSpread({}, ROUTE_DEFAULTS), {}, {
    href: href,
    title: "Tax Rates",
    icon: taxRates,
    description: ["Tax rates for your products."]
  });
};
var config_AUTHED_FILES = function AUTHED_FILES(_ref9) {
  var href = _ref9.href;
  return config_objectSpread(config_objectSpread({}, ROUTE_DEFAULTS), {}, {
    href: href,
    title: "Files",
    icon: files,
    description: ["Files and content to sell with your products."]
  });
};
var config_AUTHED_CAMPAIGNS = function AUTHED_CAMPAIGNS(_ref10) {
  var href = _ref10.href;
  return config_objectSpread(config_objectSpread({}, ROUTE_DEFAULTS), {}, {
    href: href,
    title: "Campaigns",
    icon: campaigns,
    description: ["Campaigns to get paid."]
  });
};
var config_AUTHED_SETTINGS = function AUTHED_SETTINGS(_ref11) {
  var href = _ref11.href;
  return config_objectSpread(config_objectSpread({}, ROUTE_DEFAULTS), {}, {
    href: href,
    title: "Settings",
    icon: settings,
    description: ["Manage your app settings."]
  });
};
var AUTHED_ACCOUNT = config_objectSpread(config_objectSpread({}, ROUTE_DEFAULTS), {}, {
  href: paths["d" /* default */].ACCOUNT,
  title: "Account",
  icon: account,
  description: ["Your account and connected merchant account information"]
});
var AUTHED_DEVELOPMENT = config_objectSpread(config_objectSpread({}, ROUTE_DEFAULTS), {}, {
  href: paths["d" /* default */].DEVELOPMENT,
  title: "Development",
  scheme: styles["b" /* COLOR_SCHEME_KEYS */].BLUE,
  icon: code,
  description: ["Your information for secure integrations"]
});
var AUTHED_PRICING = config_objectSpread(config_objectSpread({}, ROUTE_DEFAULTS), {}, {
  hoc: hocs_AuthedPricingHOC,
  title: "Plans",
  scheme: styles["b" /* COLOR_SCHEME_KEYS */].BLUE,
  icon: plans,
  description: ["Pick the right plan for you or your team"]
});
var AUTHED_BILLING = config_objectSpread(config_objectSpread({}, ROUTE_DEFAULTS), {}, {
  hoc: hocs_AuthedBillingHOC,
  title: "Billing",
  scheme: styles["b" /* COLOR_SCHEME_KEYS */].BLUE,
  icon: Icons_billing,
  description: ["See your invoices, manage your subscription and payment methods."]
});
/**
 * ================
 * Unauthed
 * ================
 */

var UNAUTHED_PRICING = config_objectSpread(config_objectSpread({}, ROUTE_DEFAULTS), {}, {
  href: paths["d" /* default */].PRICING,
  title: "Plans",
  scheme: styles["b" /* COLOR_SCHEME_KEYS */].BLUE,
  icon: plans,
  description: ["Pick the right plan for you or your team"]
});
var UNAUTHED_LINKS = config_objectSpread(config_objectSpread({}, ROUTE_DEFAULTS), {}, {
  href: paths["d" /* default */].FEATURES_LINKS_BUILDER,
  title: "Builder",
  scheme: styles["b" /* COLOR_SCHEME_KEYS */].BLUE,
  icon: links,
  description: ["Build a payment link in just a few clicks."]
});
var UNAUTHED_CHANNELS = config_objectSpread(config_objectSpread({}, ROUTE_DEFAULTS), {}, {
  href: paths["d" /* default */].FEATURES_CHANNELS,
  title: "Channels",
  scheme: styles["b" /* COLOR_SCHEME_KEYS */].BLUE,
  icon: channels,
  description: ["See how payment links can be used in any channel."]
});
var UNAUTHED_TUTORIAL = config_objectSpread(config_objectSpread({}, ROUTE_DEFAULTS), {}, {
  href: paths["d" /* default */].TUTORIALS,
  zone: paths["d" /* default */].TUTORIALS,
  title: "Tutorials",
  scheme: styles["b" /* COLOR_SCHEME_KEYS */].BLUE,
  icon: tutorial,
  description: ["Learn how to use PriceBlocs payment links across all of your channels."]
});
var UNAUTHED_LEARN = config_objectSpread(config_objectSpread({}, ROUTE_DEFAULTS), {}, {
  href: paths["d" /* default */].LEARN,
  zone: paths["d" /* default */].LEARN,
  title: "Learn",
  scheme: styles["b" /* COLOR_SCHEME_KEYS */].BLUE,
  icon: learn,
  description: ["Learn how to configure and use your PriceBlocs account."]
});
var UNAUTHED_DOCS = config_objectSpread(config_objectSpread({}, ROUTE_DEFAULTS), {}, {
  href: paths["d" /* default */].DOCS,
  zone: paths["d" /* default */].DOCS,
  title: "Documentation",
  scheme: styles["b" /* COLOR_SCHEME_KEYS */].BLUE,
  icon: docs,
  description: ["Learn how to develop on PriceBlocs."]
});
// EXTERNAL MODULE: ./src/utils/constants/navigation.js
var navigation = __webpack_require__("PZOY");

// CONCATENATED MODULE: ./src/components/Nav/routes.jsx


function routes_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function routes_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { routes_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { routes_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var NAV_SECTION_IDS = {
  PROFILE: "profile",
  LINKS: "links",
  PAGES: "pages",
  PRICING: "pricing",
  RESOURCES: "resources",
  TUTORIALS: "tutorials",
  LEARN: "learn",
  DOCUMENTATION: "documentation",
  INTEGRATIONS: "integrations"
};
var routes_DEFAULT_STYLE = {
  highlight: true
};
var tutorialGroup = {
  style: routes_DEFAULT_STYLE,
  label: "Tutorials",
  href: paths["d" /* default */].TUTORIALS,
  zone: paths["d" /* default */].TUTORIALS,
  sectionId: NAV_SECTION_IDS.TUTORIALS,
  subnav: {
    title: "Tutorials Overview",
    nodes: [UNAUTHED_TUTORIAL]
  }
};
var learnGroup = {
  style: routes_DEFAULT_STYLE,
  label: "Learn",
  href: paths["d" /* default */].LEARN,
  zone: paths["d" /* default */].LEARN,
  sectionId: NAV_SECTION_IDS.DOCUMENTATION,
  subnav: {
    title: "Learn Overview",
    nodes: [UNAUTHED_LEARN]
  }
};
var routes_unauthedRoutes = function unauthedRoutes() {
  return [{
    href: Object(utils_auth["d" /* getJWT */])() ? paths["d" /* default */].HUB : paths["d" /* default */].HOME,
    icon: brand,
    style: routes_objectSpread(routes_objectSpread({}, routes_DEFAULT_STYLE), {}, {
      highlight: false
    })
  }, {
    style: routes_DEFAULT_STYLE,
    label: "Payment Links",
    href: paths["d" /* default */].FEATURES_LINKS_BUILDER,
    sectionId: NAV_SECTION_IDS.LINKS,
    subnav: {
      title: "Payment Links Overview",
      nodes: [UNAUTHED_LINKS, UNAUTHED_CHANNELS]
    }
  }, {
    style: routes_DEFAULT_STYLE,
    label: "Pricing",
    href: paths["d" /* default */].PRICING,
    sectionId: NAV_SECTION_IDS.PRICING,
    subnav: {
      title: "Pricing Overview",
      nodes: [UNAUTHED_PRICING]
    }
  }, tutorialGroup, learnGroup // {
  //   style: DEFAULT_STYLE,
  //   label: "Plan",
  //   sectionId: PATHS.PLAN,
  //   subnav: {
  //     title: "PLAN OVERVIEW",
  //     nodes: compact([
  //       UNAUTHED_PLAN,
  //       UNAUTHED_LEVELS,
  //       UNAUTHED_PRODUCTS,
  //       flags.app.evaluate && UNAUTHED_EVALUATE
  //     ])
  //   }
  // },
  // {
  //   style: DEFAULT_STYLE,
  //   label: "Documentation",
  //   sectionId: PATHS.MARKETPLACE,
  //   subnav: {
  //     title: "Resources Overview",
  //     nodes: [UNAUTHED_MARKETPLACE, UNAUTHED_SUGGESTIONS]
  //   }
  // },
  // {
  //   style: DEFAULT_STYLE,
  //   label: "Team",
  //   sectionId: PATHS.TEAM,
  //   callout: "New",
  //   subnav: {
  //     title: "Team Overview",
  //     nodes: [UNAUTHED_TEAM]
  //   }
  // }
  ];
};
var routes_authedRoutes = function authedRoutes(_ref) {
  var route = _ref.route,
      isDesktop = _ref.isDesktop,
      appRoot = _ref.appRoot,
      inBeta = _ref.inBeta;
  var nodes = [];

  if (route !== paths["d" /* default */].ONBOARDING) {
    // const flags = capabilityFlags(capabilities);
    var hubGroup = {
      href: paths["d" /* default */].HUB,
      icon: brand,
      style: routes_objectSpread(routes_objectSpread({}, routes_DEFAULT_STYLE), {}, {
        highlight: false
      })
    };
    var pricingGroup = {
      style: routes_DEFAULT_STYLE,
      label: "Pricing",
      hoc: hocs_AuthedPricingHOC,
      sectionId: NAV_SECTION_IDS.PRICING,
      subnav: {
        title: "Pricing Overview",
        nodes: [AUTHED_PRICING, AUTHED_BILLING]
      }
    };
    var accountGroup = {
      style: routes_DEFAULT_STYLE,
      label: "Account",
      href: paths["d" /* default */].PROFILE,
      sectionId: NAV_SECTION_IDS.PROFILE,
      subnav: {
        title: "Account Overview",
        nodes: [AUTHED_PROFILE, config_AUTHED_SETTINGS({
          href: "".concat(appRoot, "/").concat(navigation["a" /* HUB_APP_SUB_SECTION */].SETTINGS)
        })]
      }
    };

    if (isDesktop) {
      nodes = [hubGroup, {
        style: routes_DEFAULT_STYLE,
        label: "Pages",
        href: "".concat(appRoot, "/").concat(navigation["a" /* HUB_APP_SUB_SECTION */].HOME),
        sectionId: NAV_SECTION_IDS.HOME,
        subnav: {
          title: "Pages Overview",
          nodes: [config_AUTHED_HOME({
            href: "".concat(appRoot, "/").concat(navigation["a" /* HUB_APP_SUB_SECTION */].HOME)
          }), config_AUTHED_SALES({
            href: "".concat(appRoot, "/").concat(navigation["a" /* HUB_APP_SUB_SECTION */].SALES)
          }), config_AUTHED_LINKS({
            href: "".concat(appRoot, "/").concat(navigation["a" /* HUB_APP_SUB_SECTION */].LINKS)
          }), config_AUTHED_PRODUCTS({
            href: "".concat(appRoot, "/").concat(navigation["a" /* HUB_APP_SUB_SECTION */].PRODUCTS)
          }), config_AUTHED_COUPONS({
            href: "".concat(appRoot, "/").concat(navigation["a" /* HUB_APP_SUB_SECTION */].COUPONS)
          }), config_AUTHED_TAX_RATES({
            href: "".concat(appRoot, "/").concat(kebabCase_default()(navigation["a" /* HUB_APP_SUB_SECTION */].TAX_RATES))
          }), config_AUTHED_FILES({
            href: "".concat(appRoot, "/").concat(navigation["a" /* HUB_APP_SUB_SECTION */].FILES)
          }), inBeta && config_AUTHED_CAMPAIGNS({
            href: "".concat(appRoot, "/").concat(navigation["a" /* HUB_APP_SUB_SECTION */].CAMPAIGNS)
          }), inBeta && config_AUTHED_PAGES({
            href: "".concat(appRoot, "/").concat(navigation["a" /* HUB_APP_SUB_SECTION */].PAGES)
          }), inBeta && config_AUTHED_ANALYTICS({
            href: "".concat(appRoot, "/").concat(navigation["a" /* HUB_APP_SUB_SECTION */].ANALYTICS)
          })]
        }
      }, pricingGroup, accountGroup, tutorialGroup, learnGroup];
    } else {
      nodes = [hubGroup, {
        style: routes_DEFAULT_STYLE,
        label: "Pages",
        href: "".concat(appRoot, "/").concat(navigation["a" /* HUB_APP_SUB_SECTION */].HOME),
        sectionId: navigation["a" /* HUB_APP_SUB_SECTION */].HOME,
        subnav: {
          title: "Sections Overview",
          nodes: compact_default()([config_AUTHED_HOME({
            href: "".concat(appRoot, "/").concat(navigation["a" /* HUB_APP_SUB_SECTION */].HOME)
          }), config_AUTHED_SALES({
            href: "".concat(appRoot, "/").concat(navigation["a" /* HUB_APP_SUB_SECTION */].SALES)
          }), config_AUTHED_LINKS({
            href: "".concat(appRoot, "/").concat(navigation["a" /* HUB_APP_SUB_SECTION */].LINKS)
          }), config_AUTHED_PRODUCTS({
            href: "".concat(appRoot, "/").concat(navigation["a" /* HUB_APP_SUB_SECTION */].PRODUCTS)
          }), config_AUTHED_COUPONS({
            href: "".concat(appRoot, "/").concat(navigation["a" /* HUB_APP_SUB_SECTION */].COUPONS)
          }), config_AUTHED_TAX_RATES({
            href: "".concat(appRoot, "/").concat(kebabCase_default()(navigation["a" /* HUB_APP_SUB_SECTION */].TAX_RATES))
          }), config_AUTHED_FILES({
            href: "".concat(appRoot, "/").concat(navigation["a" /* HUB_APP_SUB_SECTION */].FILES)
          }), inBeta && config_AUTHED_CAMPAIGNS({
            href: "".concat(appRoot, "/").concat(navigation["a" /* HUB_APP_SUB_SECTION */].CAMPAIGNS)
          }), inBeta && config_AUTHED_PAGES({
            href: "".concat(appRoot, "/").concat(navigation["a" /* HUB_APP_SUB_SECTION */].PAGES)
          }), inBeta && config_AUTHED_ANALYTICS({
            href: "".concat(appRoot, "/").concat(navigation["a" /* HUB_APP_SUB_SECTION */].ANALYTICS)
          })])
        }
      }, pricingGroup, accountGroup, tutorialGroup, learnGroup];
    }
  }

  return nodes;
};
// CONCATENATED MODULE: ./src/utils/hooks/hub.js


function hub_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function hub_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { hub_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { hub_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var hub_ensureDefaultHubRoute = function ensureDefaultHubRoute() {
  var router = Object(next_router["useRouter"])();
  var application = Object(es["d" /* useSelector */])(function (state) {
    var appId = Object(mapStateToProps["h" /* getInitialCtxApplicationId */])(state);
    var appMatch;

    if (appId) {
      appMatch = state.getIn(["application", "data"]).find(function (app) {
        return app.get("id") === appId;
      });
    }

    return appMatch ? appMatch.toJS() : null;
  });
  Object(react["useEffect"])(function () {
    if (application) {
      var destination = "".concat(Object(utils_route["d" /* interpolateRouteWithParams */])(paths["d" /* default */].HUB_APPLICATIONS_SHOW, {
        application: application
      }), "/").concat(navigation["a" /* HUB_APP_SUB_SECTION */].HOME);

      if (router.pathname !== destination) {
        router.replace(destination);
      }
    }
  }, [application, router.pathname]);
};
var hub_useHubActiveSection = function useHubActiveSection() {
  var _useRouter = Object(next_router["useRouter"])(),
      pathname = _useRouter.pathname;

  return pathname.replace("".concat(paths["d" /* default */].HUB_APPLICATIONS_SHOW, "/"), "").split("/")[0];
};
var hub_useAppHubRoute = function useAppHubRoute(path, models) {
  var _useCtxReferences = Object(selectors["j" /* useCtxReferences */])(),
      application = _useCtxReferences.application;

  return application ? Object(utils_route["d" /* interpolateRouteWithParams */])(path || paths["d" /* default */].HUB_APPLICATIONS_SHOW, hub_objectSpread({
    application: application
  }, models)) : "";
};
var hub_usePrevPathFragment = function usePrevPathFragment() {
  var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

  var _useRouter2 = Object(next_router["useRouter"])(),
      asPath = _useRouter2.asPath;

  var parts = asPath.split("/");
  var previousPath = parts.slice(0, parts.length - count).join("/");
  return previousPath;
};
// EXTERNAL MODULE: ./src/utils/hooks/index.js + 2 modules
var hooks = __webpack_require__("ik3Y");

// CONCATENATED MODULE: ./src/utils/hooks/navigation.js








var navigation_useRouteConfig = function useRouteConfig() {
  var isAuthed = Object(selectors["o" /* useIsAuthed */])();
  var inBeta = Object(hooks["a" /* useInBeta */])();
  var capabilities = Object(es["d" /* useSelector */])(function (state) {
    return Object(mapStateToProps["c" /* getCapabilities */])(state);
  });

  var _useRouter = Object(next_router["useRouter"])(),
      route = _useRouter.route;

  var _useViewport = Object(context["d" /* useViewport */])(),
      isDesktop = _useViewport.isDesktop;

  var appRoot = hub_useAppHubRoute();
  var input = {
    capabilities: capabilities,
    route: route,
    isDesktop: isDesktop,
    appRoot: appRoot,
    inBeta: inBeta
  };
  return isAuthed ? routes_authedRoutes(input) : routes_unauthedRoutes(input);
};
// EXTERNAL MODULE: ./src/utils/view.js
var view = __webpack_require__("x9nw");

// CONCATENATED MODULE: ./src/components/Nav/DesktopNav/index.jsx


var DesktopNav_jsx = react_default.a.createElement;

function DesktopNav_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function DesktopNav_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { DesktopNav_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { DesktopNav_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var LoadingNodes = function LoadingNodes(count) {
  return new Array(count).fill("").map(function (nodeIx) {
    return DesktopNav_jsx("li", {
      key: nodeIx
    }, DesktopNav_jsx("div", {
      className: "navLink__label color-text--primary db br2 pa2 shimmer h2 w3 ml3"
    }));
  });
};

var DesktopNav_DesktopNav = function DesktopNav() {
  var authLoading = Object(selectors["f" /* useAuthLoading */])();

  var _useRouter = Object(next_router["useRouter"])(),
      route = _useRouter.route;

  var _useNavContext = useNavContext(),
      values = _useNavContext.values,
      setValues = _useNavContext.setValues;

  var routeConfig = navigation_useRouteConfig();
  var navNodes = routeConfig.map(function (config, routeIndex) {
    /**
     * Debug testing override for blue active bar on nav node
     */
    var isActive = "/".concat(config.sectionId) === route; // const isActive = config.sectionId === route;

    var nodeProps = {
      href: config.href,
      zone: Boolean(config.zone),
      hoc: config.hoc,
      label: config.label,
      highlight: config.style.highlight,
      subnav: config.subnav,
      sectionId: config.sectionId,
      callout: config.callout,
      IconComp: config.icon,
      routeProps: config,
      linkProps: {
        className: classnames_default()("", {
          "fw6": isActive,
          "navLink__label color-text--primary link db br2 f5 pa2 fw5": routeIndex
        })
      },
      isActive: isActive
    };
    return DesktopNav_jsx(Nav_LinkNode, Object(esm_extends["a" /* default */])({
      key: routeIndex
    }, nodeProps));
  });
  return DesktopNav_jsx("nav", {
    key: "desktopNav",
    className: "desktopNav dn db-l fixed top-0 left-0 right-0 z-6 bg-white"
  }, DesktopNav_jsx("ul", {
    style: ui["h" /* NAV_BAR_STYLES */],
    className: "pa0 ma0 flex flex-row items-center hairline-1 bb w-100 list"
  }, DesktopNav_jsx("div", {
    className: "flex flex-row justify-between items-center h-100",
    onMouseLeave: function onMouseLeave() {
      setValues(DesktopNav_objectSpread(DesktopNav_objectSpread({}, values), {}, {
        close: true,
        activeSection: null
      }));
    }
  }, authLoading || Object(view["a" /* isServer */])() ? DesktopNav_jsx(LoadingNodes, {
    count: routeConfig.length
  }) : DesktopNav_jsx(react["Fragment"], null, navNodes, DesktopNav_jsx("div", {
    key: "desktopAuth",
    className: "dib h-100 flex items-center bb bw1 b--transparent absolute right-1"
  }, DesktopNav_jsx(Nav_AuthButton, null))))));
};

/* harmony default export */ var Nav_DesktopNav = (DesktopNav_DesktopNav);
// EXTERNAL MODULE: ./node_modules/react-icons/io/index.esm.js
var index_esm = __webpack_require__("IdFE");

// EXTERNAL MODULE: ./src/components/Form/fields/constants.js
var constants = __webpack_require__("eLLw");

// CONCATENATED MODULE: ./src/components/Nav/MobileNav/ClosedMobileMenu.jsx


var ClosedMobileMenu_jsx = react_default.a.createElement;

function ClosedMobileMenu_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ClosedMobileMenu_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ClosedMobileMenu_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ClosedMobileMenu_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














var ClosedMobileMenu_ClosedMobileMenu = function ClosedMobileMenu() {
  var _useNavContext = useNavContext(),
      values = _useNavContext.values,
      setValues = _useNavContext.setValues;

  var isAuthed = Object(selectors["o" /* useIsAuthed */])();
  var hubPath = hub_useAppHubRoute();
  var logoHref = isAuthed ? "".concat(hubPath, "/").concat(navigation["a" /* HUB_APP_SUB_SECTION */].HOME) : Object(utils_auth["d" /* getJWT */])() ? paths["d" /* default */].HUB : paths["d" /* default */].HOME;
  return ClosedMobileMenu_jsx("ul", {
    style: ui["h" /* NAV_BAR_STYLES */],
    className: "ma0 flex flex-items justify-between pa0 bb hairline-1 ba"
  }, ClosedMobileMenu_jsx("li", {
    className: "dib o-0 flex pa2 w-third"
  }), ClosedMobileMenu_jsx("li", {
    className: "dib flex items-center justify-center pa2 w-third"
  }, ClosedMobileMenu_jsx(components_ZoneLink, {
    href: logoHref
  }, ClosedMobileMenu_jsx("div", {
    onClick: function onClick() {
      return setValues(ClosedMobileMenu_objectSpread(ClosedMobileMenu_objectSpread({}, values), {}, {
        open: false
      }));
    }
  }, ClosedMobileMenu_jsx(brand, null)))), ClosedMobileMenu_jsx("li", {
    className: "dib pa2 w-third flex items-center justify-end"
  }, ClosedMobileMenu_jsx(index_esm["k" /* IoIosMenu */], Object(esm_extends["a" /* default */])({
    className: "pointer"
  }, constants["d" /* ICON_PROPS */], {
    size: 40,
    onClick: function onClick() {
      return setValues(ClosedMobileMenu_objectSpread(ClosedMobileMenu_objectSpread({}, values), {}, {
        open: true
      }));
    }
  }))));
};

/* harmony default export */ var MobileNav_ClosedMobileMenu = (ClosedMobileMenu_ClosedMobileMenu);
// EXTERNAL MODULE: ./src/components/Padder/index.jsx
var Padder = __webpack_require__("gH8l");

// CONCATENATED MODULE: ./src/components/Nav/MobileNav/OpenMobileMenu.jsx


var OpenMobileMenu_jsx = react_default.a.createElement;

function OpenMobileMenu_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function OpenMobileMenu_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { OpenMobileMenu_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { OpenMobileMenu_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var OpenMobileMenu_OpenMobileMenu = function OpenMobileMenu() {
  var _useNavContext = useNavContext(),
      values = _useNavContext.values,
      setValues = _useNavContext.setValues;

  var routeConfig = navigation_useRouteConfig();

  var closeMenu = function closeMenu() {
    return setValues(OpenMobileMenu_objectSpread(OpenMobileMenu_objectSpread({}, values), {}, {
      open: false
    }));
  };

  var navNodes = routeConfig.map(function (config, key) {
    var notDashboard = config.href !== paths["d" /* default */].HUB;
    var nodeProps = {
      href: config.href,
      zone: Boolean(config.zone),
      hoc: config.hoc,
      label: config.label,
      highlight: config.style.highlight,
      subnav: config.subnav,
      sectionId: config.sectionId,
      callout: config.callout,
      routeProps: config,
      linkProps: {
        className: classnames_default()("navLink__label color-text--primary link db f4 pa3 w-100 w-auto-l fw6", {
          "bb b--black-05": notDashboard
        })
      },
      IconComp: config.icon,
      showAlways: true
    };
    return OpenMobileMenu_jsx(Nav_LinkNode, Object(esm_extends["a" /* default */])({
      key: key
    }, nodeProps));
  });
  return OpenMobileMenu_jsx("div", {
    className: "h-100 dib w-100 fixed z-1 bg-white overflow-y-scroll"
  }, OpenMobileMenu_jsx("div", {
    className: "absolute top-0 right-0 pa2 pointer z-7"
  }, OpenMobileMenu_jsx(index_esm["g" /* IoIosClose */], Object(esm_extends["a" /* default */])({}, constants["d" /* ICON_PROPS */], {
    size: 40,
    onClick: closeMenu
  }))), OpenMobileMenu_jsx("div", {
    className: "pa0 ma0"
  }, navNodes, OpenMobileMenu_jsx("div", {
    className: "w-100 hairline-1 mt3",
    onClick: closeMenu
  }, OpenMobileMenu_jsx(Nav_AuthButton, {
    key: "mobileNav",
    customClasses: {
      contextClass: ui["a" /* BUTTON_CLASS_CONTEXT */].SECONDARY
    }
  }))), OpenMobileMenu_jsx(Padder["a" /* default */], {
    theme: "visible"
  }));
};

/* harmony default export */ var MobileNav_OpenMobileMenu = (OpenMobileMenu_OpenMobileMenu);
// CONCATENATED MODULE: ./src/components/Nav/MobileNav/index.jsx
var MobileNav_jsx = react_default.a.createElement;






var MobileNav_MobileNav = function MobileNav() {
  var _useNavContext = useNavContext(),
      open = _useNavContext.values.open;

  var navClasses = classnames_default()("mobileNav db", {
    "absolute h-100 w-100 bg-white z-6": open,
    "fixed top-0 left-0 right-0 z-6 bg-white": !open
  });
  var content = open ? MobileNav_jsx(MobileNav_OpenMobileMenu, null) : MobileNav_jsx(MobileNav_ClosedMobileMenu, null);
  return MobileNav_jsx("nav", {
    key: "mobileNav",
    className: navClasses
  }, content);
};

/* harmony default export */ var Nav_MobileNav = (MobileNav_MobileNav);
// CONCATENATED MODULE: ./src/components/Nav/index.jsx
var Nav_jsx = react_default.a.createElement;






var Nav_Nav = function Nav() {
  var _useViewport = Object(context["d" /* useViewport */])(),
      isDesktop = _useViewport.isDesktop;

  return Nav_jsx(NavContextProvider, null, Nav_jsx("div", {
    className: "w-100"
  }, isDesktop ? Nav_jsx(Nav_DesktopNav, {
    key: "desktopNav"
  }) : Nav_jsx(Nav_MobileNav, {
    key: "mobileNav"
  })));
};

/* harmony default export */ var components_Nav = __webpack_exports__["a"] = (Nav_Nav);

/***/ }),

/***/ "8OQS":
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),

/***/ "Aiso":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("dQHF")


/***/ }),

/***/ "D0BC":
/***/ (function(module, exports, __webpack_require__) {

var baseRandom = __webpack_require__("vlbB"),
    isIterateeCall = __webpack_require__("mv/X"),
    toFinite = __webpack_require__("ZCgT");

/** Built-in method references without a dependency on `root`. */
var freeParseFloat = parseFloat;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min,
    nativeRandom = Math.random;

/**
 * Produces a random number between the inclusive `lower` and `upper` bounds.
 * If only one argument is provided a number between `0` and the given number
 * is returned. If `floating` is `true`, or either `lower` or `upper` are
 * floats, a floating-point number is returned instead of an integer.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Number
 * @param {number} [lower=0] The lower bound.
 * @param {number} [upper=1] The upper bound.
 * @param {boolean} [floating] Specify returning a floating-point number.
 * @returns {number} Returns the random number.
 * @example
 *
 * _.random(0, 5);
 * // => an integer between 0 and 5
 *
 * _.random(5);
 * // => also an integer between 0 and 5
 *
 * _.random(5, true);
 * // => a floating-point number between 0 and 5
 *
 * _.random(1.2, 5.2);
 * // => a floating-point number between 1.2 and 5.2
 */
function random(lower, upper, floating) {
  if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
    upper = floating = undefined;
  }
  if (floating === undefined) {
    if (typeof upper == 'boolean') {
      floating = upper;
      upper = undefined;
    }
    else if (typeof lower == 'boolean') {
      floating = lower;
      lower = undefined;
    }
  }
  if (lower === undefined && upper === undefined) {
    lower = 0;
    upper = 1;
  }
  else {
    lower = toFinite(lower);
    if (upper === undefined) {
      upper = lower;
      lower = 0;
    } else {
      upper = toFinite(upper);
    }
  }
  if (lower > upper) {
    var temp = lower;
    lower = upper;
    upper = temp;
  }
  if (floating || lower % 1 || upper % 1) {
    var rand = nativeRandom();
    return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
  }
  return baseRandom(lower, upper);
}

module.exports = random;


/***/ }),

/***/ "Djx3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return devLogger; });
var devLogger = function devLogger(message, data) {
  var prettyPrint = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (false) {}
};

/***/ }),

/***/ "HaE+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _asyncToGenerator; });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ }),

/***/ "Ji7U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ _inherits; });

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

/***/ }),

/***/ "Lnxd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ GenIcon; });

// UNUSED EXPORTS: IconsManifest, IconBase, DefaultContext, IconContext

// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconsManifest.js
var IconsManifest = [
  {
    "id": "fa",
    "name": "Font Awesome",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "io",
    "name": "Ionicons 4",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "io5",
    "name": "Ionicons 5",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "md",
    "name": "Material Design icons",
    "projectUrl": "http://google.github.io/material-design-icons/",
    "license": "Apache License Version 2.0",
    "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
  },
  {
    "id": "ti",
    "name": "Typicons",
    "projectUrl": "http://s-ings.com/typicons/",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
  },
  {
    "id": "go",
    "name": "Github Octicons icons",
    "projectUrl": "https://octicons.github.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
  },
  {
    "id": "fi",
    "name": "Feather",
    "projectUrl": "https://feathericons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
  },
  {
    "id": "gi",
    "name": "Game Icons",
    "projectUrl": "https://game-icons.net/",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
  },
  {
    "id": "wi",
    "name": "Weather Icons",
    "projectUrl": "https://erikflowers.github.io/weather-icons/",
    "license": "SIL OFL 1.1",
    "licenseUrl": "http://scripts.sil.org/OFL"
  },
  {
    "id": "di",
    "name": "Devicons",
    "projectUrl": "https://vorillaz.github.io/devicons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ai",
    "name": "Ant Design Icons",
    "projectUrl": "https://github.com/ant-design/ant-design-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "bs",
    "name": "Bootstrap Icons",
    "projectUrl": "https://github.com/twbs/icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ri",
    "name": "Remix Icon",
    "projectUrl": "https://github.com/Remix-Design/RemixIcon",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "fc",
    "name": "Flat Color Icons",
    "projectUrl": "https://github.com/icons8/flat-color-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "gr",
    "name": "Grommet-Icons",
    "projectUrl": "https://github.com/grommet/grommet-icons",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "hi",
    "name": "Heroicons",
    "projectUrl": "https://github.com/tailwindlabs/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "si",
    "name": "Simple Icons",
    "projectUrl": "https://simpleicons.org/",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "id": "im",
    "name": "IcoMoon Free",
    "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
    "license": "CC BY 4.0 License"
  },
  {
    "id": "bi",
    "name": "BoxIcons",
    "projectUrl": "https://github.com/atisawd/boxicons",
    "license": "CC BY 4.0 License"
  },
  {
    "id": "cg",
    "name": "css.gg",
    "projectUrl": "https://github.com/astrit/css.gg",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "vsc",
    "name": "VS Code Icons",
    "projectUrl": "https://github.com/microsoft/vscode-codicons",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  }
]
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconContext.js

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = react_default.a.createContext && react_default.a.createContext(DefaultContext);
// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconBase.js
var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};




function Tree2Element(tree) {
  return tree && tree.map(function (node, i) {
    return react_default.a.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}

function GenIcon(data) {
  return function (props) {
    return react_default.a.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function (conf) {
    var attr = props.attr,
        size = props.size,
        title = props.title,
        svgProps = __rest(props, ["attr", "size", "title"]);

    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + ' ' : '') + props.className;
    return react_default.a.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && react_default.a.createElement("title", null, title), props.children);
  };

  return IconContext !== undefined ? react_default.a.createElement(IconContext.Consumer, null, function (conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}
// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/index.js




/***/ }),

/***/ "LsHQ":
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__("EA7m"),
    isIterateeCall = __webpack_require__("mv/X");

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),

/***/ "QIyF":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("Kz5y");

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ "QkVN":
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__("+Qka"),
    createAssigner = __webpack_require__("LsHQ");

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),

/***/ "T1AV":
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__("t2Dn"),
    cloneBuffer = __webpack_require__("5Tg0"),
    cloneTypedArray = __webpack_require__("yP5f"),
    copyArray = __webpack_require__("Q1l4"),
    initCloneObject = __webpack_require__("+iFO"),
    isArguments = __webpack_require__("03A+"),
    isArray = __webpack_require__("Z0cm"),
    isArrayLikeObject = __webpack_require__("3L66"),
    isBuffer = __webpack_require__("DSRE"),
    isFunction = __webpack_require__("lSCD"),
    isObject = __webpack_require__("GoyQ"),
    isPlainObject = __webpack_require__("YO3V"),
    isTypedArray = __webpack_require__("c6wG"),
    safeGet = __webpack_require__("itsj"),
    toPlainObject = __webpack_require__("jeLo");

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),

/***/ "TEwj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: DEFAULT_CLASSES

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("wx14");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("Ff2n");

// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__("MX0m");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__("17x9");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// CONCATENATED MODULE: ./src/utils/propTypes.js

var ButtonStylesShape = prop_types_default.a.shape({
  color: prop_types_default.a.string,
  border: prop_types_default.a.string,
  bgColor: prop_types_default.a.string,
  bgColorHover: prop_types_default.a.string,
  borderWidth: prop_types_default.a.number
});
var ButtonClassesShape = prop_types_default.a.shape({
  button: prop_types_default.a.string
});
var ButtonPropTypes = {
  type: prop_types_default.a.string,
  onClick: prop_types_default.a.func,
  href: prop_types_default.a.string,
  disabled: prop_types_default.a.bool,
  loading: prop_types_default.a.bool,
  // TODO: use only classes || customClasses not both
  classes: ButtonClassesShape,
  copy: prop_types_default.a.string,
  styles: ButtonStylesShape,
  tag: prop_types_default.a.oneOf(["button", "a", "link"])
};
var GridPropTypes = prop_types_default.a.shape({
  phone: prop_types_default.a.number,
  mobile: prop_types_default.a.number,
  desktop: prop_types_default.a.number,
  xl: prop_types_default.a.number,
  xxl: prop_types_default.a.number,
  xxxl: prop_types_default.a.number
});
var RecommendationPropTypes = prop_types_default.a.shape({
  recommendation_type: prop_types_default.a.string,
  recommendation_uuid: prop_types_default.a.string,
  recommendationable_type: prop_types_default.a.string,
  recommendationable_id: prop_types_default.a.string,
  recommender_type: prop_types_default.a.string,
  recommender_id: prop_types_default.a.string,
  status: prop_types_default.a.string,
  type: prop_types_default.a.string,
  id: prop_types_default.a.string
});
var SlidePropTypes = prop_types_default.a.shape({
  header: prop_types_default.a.string,
  image: prop_types_default.a.string,
  subheader: prop_types_default.a.string,
  tertiary: prop_types_default.a.string,
  title: prop_types_default.a.string
});
var OnboardingPropTypes = prop_types_default.a.shape({
  service_user_uid: prop_types_default.a.string,
  steps: prop_types_default.a.array,
  created_at: prop_types_default.a.string,
  sections: prop_types_default.a.array,
  user_id: prop_types_default.a.string,
  status: prop_types_default.a.string,
  service: prop_types_default.a.string,
  updated_at: prop_types_default.a.string,
  id: prop_types_default.a.string,
  category: prop_types_default.a.string,
  required: prop_types_default.a.bool,
  config: prop_types_default.a.shape({
    component: prop_types_default.a.string,
    step: prop_types_default.a.string,
    content: prop_types_default.a.shape({
      slides: prop_types_default.a.arrayOf(prop_types_default.a.shape({
        image: prop_types_default.a.string,
        title: prop_types_default.a.string,
        header: prop_types_default.a.string,
        subheader: prop_types_default.a.string,
        tertiary: prop_types_default.a.string
      })),
      action: prop_types_default.a.string
    })
  })
});
var ViewPropTypes = {
  uuid: prop_types_default.a.string,
  title: prop_types_default.a.string,
  type: prop_types_default.a.string,
  computeView: prop_types_default.a.func,
  updateView: prop_types_default.a.func,
  canCreate: prop_types_default.a.bool,
  display: prop_types_default.a.shape({
    analysis: prop_types_default.a.oneOf(["pivot", "linear"]),
    presentation: prop_types_default.a.oneOf(["accumulative", "cumulative"]),
    chart: prop_types_default.a.oneOf(["number", "line", "bar", "table"]),
    pivot: prop_types_default.a.shape({
      fields: prop_types_default.a.arrayOf(prop_types_default.a.string),
      stacks: prop_types_default.a.object
    })
  })
};
var LayoutPropTypes = {
  uuid: prop_types_default.a.string,
  width: prop_types_default.a.number,
  height: prop_types_default.a.number
};
var DashboardPropTypes = {
  uuid: prop_types_default.a.string,
  title: prop_types_default.a.string,
  onDragEnd: prop_types_default.a.func.isRequired,
  computeView: prop_types_default.a.func.isRequired,
  updateView: prop_types_default.a.func.isRequired,
  updateDashboardViewLayout: prop_types_default.a.func.isRequired,
  views: prop_types_default.a.arrayOf(prop_types_default.a.shape(ViewPropTypes)),
  layouts: prop_types_default.a.arrayOf(prop_types_default.a.shape(LayoutPropTypes))
};
var DashboardMiniPropTypes = {
  uuid: prop_types_default.a.string,
  title: prop_types_default.a.string,
  computeView: prop_types_default.a.func.isRequired,
  updateView: prop_types_default.a.func.isRequired,
  updateDashboardViewLayout: prop_types_default.a.func.isRequired,
  views: prop_types_default.a.arrayOf(prop_types_default.a.shape(ViewPropTypes)),
  layouts: prop_types_default.a.arrayOf(prop_types_default.a.shape(LayoutPropTypes))
};
var PaymentMethodPropTypes = {
  payment_method_id: prop_types_default.a.string,
  fingerprint: prop_types_default.a.string,
  brand: prop_types_default.a.string,
  organization_id: prop_types_default.a.string,
  created_at: prop_types_default.a.string,
  is_default: prop_types_default.a.bool,
  status: prop_types_default.a.string,
  updated_at: prop_types_default.a.string,
  id: prop_types_default.a.string,
  uuid: prop_types_default.a.string,
  customer_id: prop_types_default.a.string,
  billing_details: prop_types_default.a.shape({
    name: prop_types_default.a.string,
    email: prop_types_default.a.string,
    phone: prop_types_default.a.number,
    address: prop_types_default.a.shape({
      city: prop_types_default.a.string,
      line1: prop_types_default.a.string,
      line2: prop_types_default.a.string,
      state: prop_types_default.a.string,
      country: prop_types_default.a.string,
      postal_code: prop_types_default.a.string
    })
  }),
  exp_month: prop_types_default.a.number,
  exp_year: prop_types_default.a.number
};
var ComputationPropTypes = {
  title: prop_types_default.a.string,
  computedAt: prop_types_default.a.string,
  display: prop_types_default.a.shape({
    capabilities: prop_types_default.a.shape({
      analysis: prop_types_default.a.arrayOf(prop_types_default.a.string),
      presentation: prop_types_default.a.arrayOf(prop_types_default.a.string),
      chart: prop_types_default.a.arrayOf(prop_types_default.a.string)
    }),
    defaults: prop_types_default.a.shape({
      analysis: prop_types_default.a.string,
      presentation: prop_types_default.a.string,
      chart: prop_types_default.a.string
    })
  }),
  meta: prop_types_default.a.shape({
    meta: prop_types_default.a.shape({
      meta: prop_types_default.a.string,
      count: prop_types_default.a.string
    })
  }),
  data: prop_types_default.a.array
};
var EntityPropTypes = {
  entity: prop_types_default.a.object,
  afterChange: prop_types_default.a.func,
  stateKey: prop_types_default.a.string,
  name: prop_types_default.a.string
};
var ProductActionType = {
  copy: prop_types_default.a.oneOfType([prop_types_default.a.shape({
    template: prop_types_default.a.string,
    value: prop_types_default.a.string
  }), prop_types_default.a.string]),
  href: prop_types_default.a.oneOfType([prop_types_default.a.shape({
    template: prop_types_default.a.string,
    value: prop_types_default.a.string
  }), prop_types_default.a.string]),
  query: prop_types_default.a.object,
  action_uid: prop_types_default.a.string,
  tag: prop_types_default.a.oneOf(["button", "a", "link"])
};
var ProductFeatureType = {
  title: prop_types_default.a.string,
  items: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    active: prop_types_default.a.bool,
    title: prop_types_default.a.string,
    uuid: prop_types_default.a.string
  }))
};
var EditorFocusType = {
  key: prop_types_default.a.string,
  value: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number])
};
var SchemaPropTypes = {
  title: prop_types_default.a.string.isRequired,
  uid: prop_types_default.a.string.isRequired,
  uuid: prop_types_default.a.string.isRequired,
  component: prop_types_default.a.string.isRequired,
  schema: prop_types_default.a.shape({
    title: prop_types_default.a.string.isRequired,
    description: prop_types_default.a.string.isRequired,
    type: prop_types_default.a.string.isRequired,
    category: prop_types_default.a.string.isRequired,
    properties: prop_types_default.a.object.isRequired
  }).isRequired
};
var ApplicationPropTypes = {
  subdomain: prop_types_default.a.string.isRequired,
  merchant_account_id: prop_types_default.a.string.isRequired,
  routes: prop_types_default.a.object,
  theme_id: prop_types_default.a.string.isRequired,
  title: prop_types_default.a.string,
  description: prop_types_default.a.string
};
var LivePropTypes = {
  weight: prop_types_default.a.number.isRequired,
  manifest: prop_types_default.a.string.isRequired,
  deployment: prop_types_default.a.string.isRequired,
  route: prop_types_default.a.string.isRequired
};
var SelectFieldPropTypes = {
  label: prop_types_default.a.string,
  name: prop_types_default.a.string.isRequired,
  value: prop_types_default.a.string,
  disabled: prop_types_default.a.bool,
  options: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    uid: prop_types_default.a.string.isRequired,
    label: prop_types_default.a.string.isRequired,
    description: prop_types_default.a.string
  })).isRequired,
  errorLabel: prop_types_default.a.string,
  customClasses: prop_types_default.a.object
};
var ShortLinkPropTypes = {
  created_at: prop_types_default.a.string,
  data: prop_types_default.a.shape({
    action_uid: prop_types_default.a.string,
    application_id: prop_types_default.a.string,
    cancel_url: prop_types_default.a.string,
    merchant_account_id: prop_types_default.a.string,
    product: prop_types_default.a.shape({
      checkout: prop_types_default.a.shape({
        payment_method_types: prop_types_default.a.arrayOf(prop_types_default.a.string),
        allow_promotion_codes: prop_types_default.a.bool,
        discounts: prop_types_default.a.arrayOf(prop_types_default.a.shape({
          coupon: prop_types_default.a.string,
          promotion_code: prop_types_default.a.string
        })),
        billing_address_collection: prop_types_default.a.string,
        shipping_address_collection: prop_types_default.a.shape({
          allowed_countries: prop_types_default.a.arrayOf(prop_types_default.a.string)
        }),
        submit_type: prop_types_default.a.string,
        tax_rates: prop_types_default.a.arrayOf(prop_types_default.a.string),
        dynamic_tax_rates: prop_types_default.a.arrayOf(prop_types_default.a.string)
      }),
      primaries: prop_types_default.a.arrayOf(prop_types_default.a.shape({
        product: prop_types_default.a.string,
        currency: prop_types_default.a.string,
        interval: prop_types_default.a.string,
        price: prop_types_default.a.string,
        quantity: prop_types_default.a.number,
        // https://stripe.com/docs/payments/checkout/taxes
        // Only allowed in subscription mode currently
        tax_rates: prop_types_default.a.arrayOf(prop_types_default.a.string),
        dynamic_tax_rates: prop_types_default.a.arrayOf(prop_types_default.a.string)
      }))
    }),
    success_url: prop_types_default.a.string
  }),
  description: prop_types_default.a.string,
  expiration: prop_types_default.a.number,
  id: prop_types_default.a.string,
  short_id: prop_types_default.a.string,
  status: prop_types_default.a.string,
  title: prop_types_default.a.string,
  updated_at: prop_types_default.a.string,
  uuid: prop_types_default.a.string
};
var TaxRatePropTypes = {
  id: prop_types_default.a.string,
  display_name: prop_types_default.a.string.isRequired,
  percentage: prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.string]),
  inclusive: prop_types_default.a.bool,
  description: prop_types_default.a.string,
  jurisdiction: prop_types_default.a.string,
  country: prop_types_default.a.string,
  state: prop_types_default.a.string
};
var AttachmentPropTypes = {
  id: prop_types_default.a.string,
  uuid: prop_types_default.a.string,
  data: prop_types_default.a.object
};
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__("YFqc");
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);

// EXTERNAL MODULE: ./src/components/LoadingSpinner/index.jsx + 1 modules
var LoadingSpinner = __webpack_require__("a/D+");

// EXTERNAL MODULE: ./node_modules/lodash/omit.js
var omit = __webpack_require__("Puqe");
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);

// EXTERNAL MODULE: ./node_modules/lodash/merge.js
var merge = __webpack_require__("QkVN");
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);

// EXTERNAL MODULE: ./src/utils/styles.js
var utils_styles = __webpack_require__("oCA+");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/utils/constants/ui.js
var ui = __webpack_require__("IWZK");

// CONCATENATED MODULE: ./src/components/Form/fields/Button.js




var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var DEFAULT_CLASSES = {
  contextClass: ui["a" /* BUTTON_CLASS_CONTEXT */].PRIMARY,
  button: "fw5 br2 ph3 pv2 border-box input-reset ba bg-transparent pointer f6 dib link items-center flex flex-shrink-0"
};
var DEFAULT_STYLES = {
  height: 40,
  borderWidth: 1,
  loading: {
    dotClass: "dot-white",
    ringClass: "white",
    sizeClass: "regular"
  }
};

var Button_Button = function Button(_ref) {
  var tag = _ref.tag,
      type = _ref.type,
      loading = _ref.loading,
      disabled = _ref.disabled,
      classes = _ref.classes,
      copy = _ref.copy,
      onClick = _ref.onClick,
      styles = _ref.styles,
      theme = _ref.theme,
      children = _ref.children,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["tag", "type", "loading", "disabled", "classes", "copy", "onClick", "styles", "theme", "children"]);

  var compClasses = merge_default()({}, DEFAULT_CLASSES, classes);
  var compStyles = merge_default()({}, DEFAULT_STYLES, ui["c" /* BUTTON_THEME */][theme], styles);
  var elClassName = classnames_default()("".concat(compClasses.contextClass, " ").concat(compClasses.button, " ").concat(ui["o" /* TA_MAN */]), Object(defineProperty["a" /* default */])({
    "cursor-not-allowed": disabled || loading
  }, "disabled-link-".concat(compClasses.contextClass), tag === ui["b" /* BUTTON_TAGS */].ANCHOR && disabled));

  var elProps = _objectSpread(_objectSpread({}, props), {}, {
    type: type,
    disabled: disabled && !loading,
    className: elClassName,
    rel: "noopener noreferrer"
  });

  if (onClick && !disabled && !loading) {
    elProps.onClick = function (evt) {
      // Allow default for a tags which are opening a new tab
      // Should be passing evt here?
      onClick();

      if (tag !== ui["b" /* BUTTON_TAGS */].ANCHOR) {
        evt.preventDefault();
      }
    };
  }

  var copyComp = __jsx("div", {
    className: "flex h-100 items-center justify-center w-100"
  }, __jsx("div", {
    className: "dib self-center user-select-n"
  }, loading ? __jsx(LoadingSpinner["a" /* default */], {
    customClasses: {
      size: compStyles.loading.sizeClass
    }
  }) : children || copy));

  var omitKeys = ["iconType", "customClasses"];

  if (tag !== ui["b" /* BUTTON_TAGS */].ANCHOR || tag === ui["b" /* BUTTON_TAGS */].ANCHOR && disabled) {
    omitKeys.push("href");
  }

  var trimmed = omit_default()(elProps, omitKeys);
  return __jsx(react["Fragment"], null, tag === ui["b" /* BUTTON_TAGS */].ANCHOR ? __jsx("a", Object(esm_extends["a" /* default */])({}, trimmed, {
    className: style_default.a.dynamic([["1977515148", [compStyles.height, compStyles.borderWidth, utils_styles["c" /* DURATION */], utils_styles["c" /* DURATION */], utils_styles["c" /* DURATION */], utils_styles["c" /* DURATION */]]]]) + " " + (trimmed && trimmed.className != null && trimmed.className || "")
  }), copyComp) : tag === ui["b" /* BUTTON_TAGS */].LINK ? __jsx(link_default.a, {
    href: elProps.href
  }, __jsx("a", Object(esm_extends["a" /* default */])({}, trimmed, {
    className: style_default.a.dynamic([["1977515148", [compStyles.height, compStyles.borderWidth, utils_styles["c" /* DURATION */], utils_styles["c" /* DURATION */], utils_styles["c" /* DURATION */], utils_styles["c" /* DURATION */]]]]) + " " + (trimmed && trimmed.className != null && trimmed.className || "")
  }), copyComp)) : __jsx("button", Object(esm_extends["a" /* default */])({
    type: ui["b" /* BUTTON_TAGS */].BUTTON
  }, trimmed, {
    className: style_default.a.dynamic([["1977515148", [compStyles.height, compStyles.borderWidth, utils_styles["c" /* DURATION */], utils_styles["c" /* DURATION */], utils_styles["c" /* DURATION */], utils_styles["c" /* DURATION */]]]]) + " " + (trimmed && trimmed.className != null && trimmed.className || "")
  }), copyComp), __jsx(style_default.a, {
    id: "1977515148",
    dynamic: [compStyles.height, compStyles.borderWidth, utils_styles["c" /* DURATION */], utils_styles["c" /* DURATION */], utils_styles["c" /* DURATION */], utils_styles["c" /* DURATION */]]
  }, ["button.__jsx-style-dynamic-selector,a.__jsx-style-dynamic-selector{outline:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;height:".concat(compStyles.height, "px;border-width:").concat(compStyles.borderWidth, "px;-webkit-transition:background-color ").concat(utils_styles["c" /* DURATION */], "s, -webkit-transform ").concat(utils_styles["c" /* DURATION */], "s;-webkit-transition:background-color ").concat(utils_styles["c" /* DURATION */], "s,-webkit-transform ").concat(utils_styles["c" /* DURATION */], "s;-webkit-transition:background-color ").concat(utils_styles["c" /* DURATION */], "s,transform ").concat(utils_styles["c" /* DURATION */], "s;transition:background-color ").concat(utils_styles["c" /* DURATION */], "s,transform ").concat(utils_styles["c" /* DURATION */], "s;}")]));
};

Button_Button.defaultProps = {
  tag: ui["b" /* BUTTON_TAGS */].BUTTON
};
/* harmony default export */ var fields_Button = __webpack_exports__["a"] = (Button_Button);

/***/ }),

/***/ "UWYU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
exports.__esModule=true;exports.imageConfigDefault=exports.VALID_LOADERS=void 0;const VALID_LOADERS=['default','imgix','cloudinary','akamai'];exports.VALID_LOADERS=VALID_LOADERS;const imageConfigDefault={deviceSizes:[640,750,828,1080,1200,1920,2048,3840],imageSizes:[16,32,48,64,96,128,256,384],path:'/_next/image',loader:'default',domains:[]};exports.imageConfigDefault=imageConfigDefault;
//# sourceMappingURL=image-config.js.map

/***/ }),

/***/ "W56c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: CDN_PLACEHOLDER_IMAGE, PLACEHOLDER_IMAGE

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("wx14");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("Ff2n");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/lodash/random.js
var random = __webpack_require__("D0BC");
var random_default = /*#__PURE__*/__webpack_require__.n(random);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__("Aiso");
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);

// EXTERNAL MODULE: ./src/utils/constants/ui.js
var ui = __webpack_require__("IWZK");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("o0o1");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("HaE+");

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("vDqi");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./src/utils/auth.js
var auth = __webpack_require__("X4fA");

// CONCATENATED MODULE: ./src/utils/constants/capability.js
var PRODUCT_FEATURE_CAPABILITY = {
  REMOVE_BRANDING: "remove_branding"
};
var ENABLED = "enabled";
var DISABLED = "disabled";
var FLAG_STATUS = {
  ENABLED: ENABLED,
  DISABLED: DISABLED
};
// EXTERNAL MODULE: ./src/utils/env.js
var utils_env = __webpack_require__("5JAB");

// CONCATENATED MODULE: ./src/utils/image.js






var signAssetPick = /*#__PURE__*/function () {
  var _ref = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
    var REQUEST_URL, _yield$axios, data;

    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            REQUEST_URL = "".concat(Object(utils_env["a" /* getConfig */])("API_ROOT"), "/v1/tutorials/assets/pick/sign");
            _context.next = 4;
            return axios_default()({
              method: "get",
              url: REQUEST_URL,
              headers: Object(auth["a" /* authBearerToken */])()
            });

          case 4:
            _yield$axios = _context.sent;
            data = _yield$axios.data;
            return _context.abrupt("return", data);

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", _context.t0);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 9]]);
  }));

  return function signAssetPick() {
    return _ref.apply(this, arguments);
  };
}();
var signAssetRead = /*#__PURE__*/function () {
  var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee2(handle) {
    var REQUEST_URL, _yield$axios2, data;

    return regenerator_default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            REQUEST_URL = "".concat(Object(utils_env["a" /* getConfig */])("API_ROOT"), "/v1/tutorials/assets/read/sign");
            _context2.next = 4;
            return axios_default()({
              method: "get",
              url: REQUEST_URL,
              params: {
                handle: handle
              },
              headers: Object(auth["a" /* authBearerToken */])()
            });

          case 4:
            _yield$axios2 = _context2.sent;
            data = _yield$axios2.data;
            return _context2.abrupt("return", data);

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", _context2.t0);

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 9]]);
  }));

  return function signAssetRead(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var isCDN = function isCDN(images) {
  var sources = Array.isArray(images) ? images : [images];
  var sourcesAreCDN = false;

  for (var sourceIx = 0; sourceIx < sources.length; sourceIx++) {
    var imageSrc = sources[sourceIx];
    sourcesAreCDN = /cdn.filestackcontent.com/.test(imageSrc);

    if (sourcesAreCDN) {
      break;
    }
  }

  return sourcesAreCDN;
};
var image_canRenderImages = function canRenderImages(images) {
  var env = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "production";
  var result = {
    canRender: false,
    hasCDNImages: false
  };
  var sources = Array.isArray(images) ? images : images ? [images] : [];
  result.canRender = sources.length > 0;
  result.hasCDNImages = result.canRender && isCDN(sources);
  /**
   * If can render and is local
   * Then check if isCDN
   * If CDN then dont render
   */

  var renderEnabled = Object(utils_env["a" /* getConfig */])("CDN_RENDER_OVERRIDE") === FLAG_STATUS.ENABLED;

  if (result.canRender && env === "development" && !renderEnabled) {
    result.canRender = !result.hasCDNImages;
  }

  return result;
};
// CONCATENATED MODULE: ./src/components/Image/index.jsx



var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var CDN_PLACEHOLDER_IMAGE = "".concat(Object(utils_env["a" /* getConfig */])("BASE_PATH"), "/assets/cdn__placeholder.png");
var PLACEHOLDER_IMAGE = "".concat(Object(utils_env["a" /* getConfig */])("BASE_PATH"), "/assets/bg__cloudMask_0.png");

var Image_Image = function Image(_ref) {
  var src = _ref.src,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["src"]);

  var _canRenderImages = image_canRenderImages(src),
      canRender = _canRenderImages.canRender,
      hasCDNImages = _canRenderImages.hasCDNImages;

  var randomIndex = Object(react["useMemo"])(function () {
    return random_default()(0, 9);
  }, []);

  if (!canRender) {
    var extra = props.height || props.width ? props : ui["k" /* PRIORITY_FILL */];

    var placeholderProps = _objectSpread({
      src: hasCDNImages ? CDN_PLACEHOLDER_IMAGE : "".concat(Object(utils_env["a" /* getConfig */])("BASE_PATH"), "/assets/bg__cloudMask_").concat(randomIndex || 1, ".png"),
      alt: props && props.title ? props.title : "placeholder"
    }, extra);

    return __jsx(image_default.a, placeholderProps);
  } else {
    return __jsx(image_default.a, Object(esm_extends["a" /* default */])({
      src: src
    }, props));
  }
};

/* harmony default export */ var components_Image = __webpack_exports__["a"] = (Image_Image);

/***/ }),

/***/ "YFqc":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("cTJO")


/***/ }),

/***/ "a/D+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: DEFAULT_CLASSES

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__("MX0m");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/styles.js
var styles = __webpack_require__("oCA+");

// CONCATENATED MODULE: ./src/components/LoadingSpinner/spinner.js

var spinnerStyles = [".priceblocs--loadingRing.jsx-3666137762{display:inline-block;position:relative;width:20px;height:20px;}", ".priceblocs--loadingRing.jsx-3666137762 div.jsx-3666137762{box-sizing:border-box;display:block;position:absolute;width:18px;height:18px;margin:2px;border-radius:50%;-webkit-animation:priceblocs--loadingRing-jsx-3666137762 1.2s cubic-bezier(0.5,0,0.5,1) infinite;animation:priceblocs--loadingRing-jsx-3666137762 1.2s cubic-bezier(0.5,0,0.5,1) infinite;}", ".priceblocs--loadingRing-small.jsx-3666137762{display:inline-block;position:relative;width:16px;height:16px;}", ".priceblocs--loadingRing-small.jsx-3666137762 div.jsx-3666137762{box-sizing:border-box;display:block;position:absolute;width:14px;height:14px;margin:2px 1px 1px 1px;border-radius:50%;-webkit-animation:priceblocs--loadingRing-jsx-3666137762 1.2s cubic-bezier(0.5,0,0.5,1) infinite;animation:priceblocs--loadingRing-jsx-3666137762 1.2s cubic-bezier(0.5,0,0.5,1) infinite;}", ".priceblocs--loadingRing-blue.jsx-3666137762{border:2px solid ".concat(styles["a" /* COLORS */].blue, ";border-color:").concat(styles["a" /* COLORS */].blue, " transparent transparent transparent;}"), ".priceblocs--loadingRing-white.jsx-3666137762{border:2px solid currentColor;border-color:currentColor transparent transparent transparent;}", ".priceblocs--loadingRing-gold.jsx-3666137762{border:2px solid currentColor;border-color:currentColor transparent transparent transparent;}", ".priceblocs--loadingRing.jsx-3666137762 div.jsx-3666137762:nth-child(1){-webkit-animation-delay:-0.45s;animation-delay:-0.45s;}", ".priceblocs--loadingRing.jsx-3666137762 div.jsx-3666137762:nth-child(2){-webkit-animation-delay:-0.3s;animation-delay:-0.3s;}", ".priceblocs--loadingRing.jsx-3666137762 div.jsx-3666137762:nth-child(3){-webkit-animation-delay:-0.15s;animation-delay:-0.15s;}", "@-webkit-keyframes priceblocs--loadingRing-jsx-3666137762{0%{-webkit-transform:rotate(0deg);-ms-transform:rotate(0deg);transform:rotate(0deg);}100%{-webkit-transform:rotate(360deg);-ms-transform:rotate(360deg);transform:rotate(360deg);}}", "@keyframes priceblocs--loadingRing-jsx-3666137762{0%{-webkit-transform:rotate(0deg);-ms-transform:rotate(0deg);transform:rotate(0deg);}100%{-webkit-transform:rotate(360deg);-ms-transform:rotate(360deg);transform:rotate(360deg);}}"];
spinnerStyles.__hash = "3666137762";
// CONCATENATED MODULE: ./src/components/LoadingSpinner/index.jsx


var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



var DEFAULT_CLASSES = {
  ring: "white",
  size: "regular"
};
var BASE_CLASS = "priceblocs--loadingRing";

var LoadingSpinner_LoadingSpinner = function LoadingSpinner(_ref) {
  var customClasses = _ref.customClasses;

  var classes = _objectSpread(_objectSpread({}, DEFAULT_CLASSES), customClasses);

  return __jsx("div", {
    className: "jsx-".concat(spinnerStyles.__hash) + " " + "".concat(BASE_CLASS, " ").concat(BASE_CLASS, "-").concat(classes.size)
  }, __jsx("div", {
    className: "jsx-".concat(spinnerStyles.__hash) + " " + "".concat(BASE_CLASS, "-").concat(classes.ring)
  }), __jsx("div", {
    className: "jsx-".concat(spinnerStyles.__hash) + " " + "".concat(BASE_CLASS, "-").concat(classes.ring)
  }), __jsx("div", {
    className: "jsx-".concat(spinnerStyles.__hash) + " " + "".concat(BASE_CLASS, "-").concat(classes.ring)
  }), __jsx("div", {
    className: "jsx-".concat(spinnerStyles.__hash) + " " + "".concat(BASE_CLASS, "-").concat(classes.ring)
  }), __jsx(style_default.a, {
    id: spinnerStyles.__hash
  }, spinnerStyles));
};

/* harmony default export */ var components_LoadingSpinner = __webpack_exports__["a"] = (LoadingSpinner_LoadingSpinner);

/***/ }),

/***/ "cTJO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__("J4zp");

var _interopRequireWildcard = __webpack_require__("284h");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__("q1tI"));

var _router = __webpack_require__("elyg");

var _router2 = __webpack_require__("nOHt");

var _useIntersection = __webpack_require__("vNVm");

var prefetched = {};

function prefetch(router, href, as, options) {
  if (false) {}
  if (!(0, _router.isLocalURL)(href)) return; // Prefetch the JSON page if asked (only in the client)
  // We need to handle a prefetch error here since we may be
  // loading with priority which can reject but we don't
  // want to force navigation since this is only a prefetch

  router.prefetch(href, as, options)["catch"](function (err) {
    if (false) {}
  });
  var curLocale = options && typeof options.locale !== 'undefined' ? options.locale : router && router.locale; // Join on an invalid URI character

  prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')] = true;
}

function isModifiedEvent(event) {
  var target = event.currentTarget.target;
  return target && target !== '_self' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || // triggers resource download
  event.nativeEvent && event.nativeEvent.which === 2;
}

function linkClicked(e, router, href, as, replace, shallow, scroll, locale) {
  var nodeName = e.currentTarget.nodeName;

  if (nodeName === 'A' && (isModifiedEvent(e) || !(0, _router.isLocalURL)(href))) {
    // ignore click for browser’s default behavior
    return;
  }

  e.preventDefault(); //  avoid scroll for urls with anchor refs

  if (scroll == null) {
    scroll = as.indexOf('#') < 0;
  } // replace state instead of push if prop is present


  router[replace ? 'replace' : 'push'](href, as, {
    shallow: shallow,
    locale: locale
  }).then(function (success) {
    if (!success) return;

    if (scroll) {
      window.scrollTo(0, 0);
      document.body.focus();
    }
  });
}

function Link(props) {
  if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }

  var p = props.prefetch !== false;
  var router = (0, _router2.useRouter)();
  var pathname = router && router.pathname || '/';

  var _react$default$useMem = _react["default"].useMemo(function () {
    var _ref = (0, _router.resolveHref)(pathname, props.href, true),
        _ref2 = _slicedToArray(_ref, 2),
        resolvedHref = _ref2[0],
        resolvedAs = _ref2[1];

    return {
      href: resolvedHref,
      as: props.as ? (0, _router.resolveHref)(pathname, props.as) : resolvedAs || resolvedHref
    };
  }, [pathname, props.href, props.as]),
      href = _react$default$useMem.href,
      as = _react$default$useMem.as;

  var children = props.children,
      replace = props.replace,
      shallow = props.shallow,
      scroll = props.scroll,
      locale = props.locale; // Deprecated. Warning shown by propType check. If the children provided is a string (<Link>example</Link>) we wrap it in an <a> tag

  if (typeof children === 'string') {
    children = /*#__PURE__*/_react["default"].createElement("a", null, children);
  } // This will return the first child, if multiple are provided it will throw an error


  var child = _react.Children.only(children);

  var childRef = child && typeof child === 'object' && child.ref;

  var _ref3 = (0, _useIntersection.useIntersection)({
    rootMargin: '200px'
  }),
      _ref4 = _slicedToArray(_ref3, 2),
      setIntersectionRef = _ref4[0],
      isVisible = _ref4[1];

  var setRef = _react["default"].useCallback(function (el) {
    setIntersectionRef(el);

    if (childRef) {
      if (typeof childRef === 'function') childRef(el);else if (typeof childRef === 'object') {
        childRef.current = el;
      }
    }
  }, [childRef, setIntersectionRef]);

  (0, _react.useEffect)(function () {
    var shouldPrefetch = isVisible && p && (0, _router.isLocalURL)(href);
    var curLocale = typeof locale !== 'undefined' ? locale : router && router.locale;
    var isPrefetched = prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')];

    if (shouldPrefetch && !isPrefetched) {
      prefetch(router, href, as, {
        locale: curLocale
      });
    }
  }, [as, href, isVisible, locale, p, router]);
  var childProps = {
    ref: setRef,
    onClick: function onClick(e) {
      if (child.props && typeof child.props.onClick === 'function') {
        child.props.onClick(e);
      }

      if (!e.defaultPrevented) {
        linkClicked(e, router, href, as, replace, shallow, scroll, locale);
      }
    }
  };

  childProps.onMouseEnter = function (e) {
    if (!(0, _router.isLocalURL)(href)) return;

    if (child.props && typeof child.props.onMouseEnter === 'function') {
      child.props.onMouseEnter(e);
    }

    prefetch(router, href, as, {
      priority: true
    });
  }; // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
  // defined, we specify the current 'href', so that repetition is not needed by the user


  if (props.passHref || child.type === 'a' && !('href' in child.props)) {
    childProps.href = (0, _router.addBasePath)((0, _router.addLocale)(as, typeof locale !== 'undefined' ? locale : router && router.locale, router && router.defaultLocale));
  }

  return /*#__PURE__*/_react["default"].cloneElement(child, childProps);
}

var _default = Link;
exports["default"] = _default;

/***/ }),

/***/ "dEHY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.toBase64 = toBase64;
/**
* Isomorphic base64 that works on the server and client
*/

function toBase64(str) {
  if (false) {} else {
    return window.btoa(str);
  }
}

/***/ }),

/***/ "dQHF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__("J4zp");

var _toConsumableArray = __webpack_require__("RIqP");

var _interopRequireDefault = __webpack_require__("TqRt");

exports.__esModule = true;
exports["default"] = Image;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__("8OQS"));

var _extends2 = _interopRequireDefault(__webpack_require__("pVnL"));

var _react = _interopRequireDefault(__webpack_require__("q1tI"));

var _toBase = __webpack_require__("dEHY");

var _imageConfig = __webpack_require__("UWYU");

var _useIntersection = __webpack_require__("vNVm");

if (false) {}

var VALID_LOADING_VALUES = ['lazy', 'eager', undefined];
var loaders = new Map([['imgix', imgixLoader], ['cloudinary', cloudinaryLoader], ['akamai', akamaiLoader], ['default', defaultLoader]]);
var VALID_LAYOUT_VALUES = ['fill', 'fixed', 'intrinsic', 'responsive', undefined];

var _ref2 = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/tutorials/_next/image","loader":"default"} || _imageConfig.imageConfigDefault,
    configDeviceSizes = _ref2.deviceSizes,
    configImageSizes = _ref2.imageSizes,
    configLoader = _ref2.loader,
    configPath = _ref2.path,
    configDomains = _ref2.domains; // sort smallest to largest


var allSizes = [].concat(_toConsumableArray(configDeviceSizes), _toConsumableArray(configImageSizes));
configDeviceSizes.sort(function (a, b) {
  return a - b;
});
allSizes.sort(function (a, b) {
  return a - b;
});

function getWidths(width, layout) {
  if (typeof width !== 'number' || layout === 'fill' || layout === 'responsive') {
    return {
      widths: configDeviceSizes,
      kind: 'w'
    };
  }

  var widths = _toConsumableArray(new Set([width, width * 2, width * 3].map(function (w) {
    return allSizes.find(function (p) {
      return p >= w;
    }) || allSizes[allSizes.length - 1];
  })));

  return {
    widths: widths,
    kind: 'x'
  };
}

function callLoader(loaderProps) {
  var load = loaders.get(configLoader);

  if (load) {
    return load((0, _extends2["default"])({
      root: configPath
    }, loaderProps));
  }

  throw new Error("Unknown \"loader\" found in \"next.config.js\". Expected: ".concat(_imageConfig.VALID_LOADERS.join(', '), ". Received: ").concat(configLoader));
}

function generateImgAttrs(_ref3) {
  var src = _ref3.src,
      unoptimized = _ref3.unoptimized,
      layout = _ref3.layout,
      width = _ref3.width,
      quality = _ref3.quality,
      sizes = _ref3.sizes;

  if (unoptimized) {
    return {
      src: src
    };
  }

  var _getWidths = getWidths(width, layout),
      widths = _getWidths.widths,
      kind = _getWidths.kind;

  var last = widths.length - 1;
  var srcSet = widths.map(function (w, i) {
    return "".concat(callLoader({
      src: src,
      quality: quality,
      width: w
    }), " ").concat(kind === 'w' ? w : i + 1).concat(kind);
  }).join(', ');

  if (!sizes && kind === 'w') {
    sizes = '100vw';
  }

  src = callLoader({
    src: src,
    quality: quality,
    width: widths[last]
  });
  return {
    src: src,
    sizes: sizes,
    srcSet: srcSet
  };
}

function getInt(x) {
  if (typeof x === 'number') {
    return x;
  }

  if (typeof x === 'string') {
    return parseInt(x, 10);
  }

  return undefined;
}

function Image(_ref) {
  var src = _ref.src,
      sizes = _ref.sizes,
      _ref$unoptimized = _ref.unoptimized,
      unoptimized = _ref$unoptimized === void 0 ? false : _ref$unoptimized,
      _ref$priority = _ref.priority,
      priority = _ref$priority === void 0 ? false : _ref$priority,
      loading = _ref.loading,
      className = _ref.className,
      quality = _ref.quality,
      width = _ref.width,
      height = _ref.height,
      objectFit = _ref.objectFit,
      objectPosition = _ref.objectPosition,
      all = (0, _objectWithoutPropertiesLoose2["default"])(_ref, ["src", "sizes", "unoptimized", "priority", "loading", "className", "quality", "width", "height", "objectFit", "objectPosition"]);
  var rest = all;
  var layout = sizes ? 'responsive' : 'intrinsic';
  var unsized = false;

  if ('unsized' in rest) {
    unsized = Boolean(rest.unsized); // Remove property so it's not spread into image:

    delete rest['unsized'];
  } else if ('layout' in rest) {
    // Override default layout if the user specified one:
    if (rest.layout) layout = rest.layout; // Remove property so it's not spread into image:

    delete rest['layout'];
  }

  if (false) {}

  var isLazy = !priority && (loading === 'lazy' || typeof loading === 'undefined');

  if (src && src.startsWith('data:')) {
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
    unoptimized = true;
    isLazy = false;
  }

  var _ref4 = (0, _useIntersection.useIntersection)({
    rootMargin: '200px',
    disabled: !isLazy
  }),
      _ref5 = _slicedToArray(_ref4, 2),
      setRef = _ref5[0],
      isIntersected = _ref5[1];

  var isVisible = !isLazy || isIntersected;
  var widthInt = getInt(width);
  var heightInt = getInt(height);
  var qualityInt = getInt(quality);
  var wrapperStyle;
  var sizerStyle;
  var sizerSvg;
  var imgStyle = {
    visibility: isVisible ? 'visible' : 'hidden',
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    boxSizing: 'border-box',
    padding: 0,
    border: 'none',
    margin: 'auto',
    display: 'block',
    width: 0,
    height: 0,
    minWidth: '100%',
    maxWidth: '100%',
    minHeight: '100%',
    maxHeight: '100%',
    objectFit: objectFit,
    objectPosition: objectPosition
  };

  if (typeof widthInt !== 'undefined' && typeof heightInt !== 'undefined' && layout !== 'fill') {
    // <Image src="i.png" width="100" height="100" />
    var quotient = heightInt / widthInt;
    var paddingTop = isNaN(quotient) ? '100%' : "".concat(quotient * 100, "%");

    if (layout === 'responsive') {
      // <Image src="i.png" width="100" height="100" layout="responsive" />
      wrapperStyle = {
        display: 'block',
        overflow: 'hidden',
        position: 'relative',
        boxSizing: 'border-box',
        margin: 0
      };
      sizerStyle = {
        display: 'block',
        boxSizing: 'border-box',
        paddingTop: paddingTop
      };
    } else if (layout === 'intrinsic') {
      // <Image src="i.png" width="100" height="100" layout="intrinsic" />
      wrapperStyle = {
        display: 'inline-block',
        maxWidth: '100%',
        overflow: 'hidden',
        position: 'relative',
        boxSizing: 'border-box',
        margin: 0
      };
      sizerStyle = {
        boxSizing: 'border-box',
        display: 'block',
        maxWidth: '100%'
      };
      sizerSvg = "<svg width=\"".concat(widthInt, "\" height=\"").concat(heightInt, "\" xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\"/>");
    } else if (layout === 'fixed') {
      // <Image src="i.png" width="100" height="100" layout="fixed" />
      wrapperStyle = {
        overflow: 'hidden',
        boxSizing: 'border-box',
        display: 'inline-block',
        position: 'relative',
        width: widthInt,
        height: heightInt
      };
    }
  } else if (typeof widthInt === 'undefined' && typeof heightInt === 'undefined' && layout === 'fill') {
    // <Image src="i.png" layout="fill" />
    wrapperStyle = {
      display: 'block',
      overflow: 'hidden',
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      boxSizing: 'border-box',
      margin: 0
    };
  } else {
    // <Image src="i.png" />
    if (false) {}
  }

  var imgAttributes = {
    src: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
  };

  if (isVisible) {
    imgAttributes = generateImgAttrs({
      src: src,
      unoptimized: unoptimized,
      layout: layout,
      width: widthInt,
      quality: qualityInt,
      sizes: sizes
    });
  }

  if (unsized) {
    wrapperStyle = undefined;
    sizerStyle = undefined;
    imgStyle = undefined;
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    style: wrapperStyle
  }, sizerStyle ? /*#__PURE__*/_react["default"].createElement("div", {
    style: sizerStyle
  }, sizerSvg ? /*#__PURE__*/_react["default"].createElement("img", {
    style: {
      maxWidth: '100%',
      display: 'block'
    },
    alt: "",
    "aria-hidden": true,
    role: "presentation",
    src: "data:image/svg+xml;base64,".concat((0, _toBase.toBase64)(sizerSvg))
  }) : null) : null, /*#__PURE__*/_react["default"].createElement("img", Object.assign({}, rest, imgAttributes, {
    decoding: "async",
    className: className,
    ref: setRef,
    style: imgStyle
  })));
} //BUILT IN LOADERS


function normalizeSrc(src) {
  return src[0] === '/' ? src.slice(1) : src;
}

function imgixLoader(_ref6) {
  var root = _ref6.root,
      src = _ref6.src,
      width = _ref6.width,
      quality = _ref6.quality;
  // Demo: https://static.imgix.net/daisy.png?format=auto&fit=max&w=300
  var params = ['auto=format', 'fit=max', 'w=' + width];
  var paramsString = '';

  if (quality) {
    params.push('q=' + quality);
  }

  if (params.length) {
    paramsString = '?' + params.join('&');
  }

  return "".concat(root).concat(normalizeSrc(src)).concat(paramsString);
}

function akamaiLoader(_ref7) {
  var root = _ref7.root,
      src = _ref7.src,
      width = _ref7.width;
  return "".concat(root).concat(normalizeSrc(src), "?imwidth=").concat(width);
}

function cloudinaryLoader(_ref8) {
  var root = _ref8.root,
      src = _ref8.src,
      width = _ref8.width,
      quality = _ref8.quality;
  // Demo: https://res.cloudinary.com/demo/image/upload/w_300,c_limit,q_auto/turtles.jpg
  var params = ['f_auto', 'c_limit', 'w_' + width, 'q_' + (quality || 'auto')];
  var paramsString = params.join(',') + '/';
  return "".concat(root).concat(paramsString).concat(normalizeSrc(src));
}

function defaultLoader(_ref9) {
  var root = _ref9.root,
      src = _ref9.src,
      width = _ref9.width,
      quality = _ref9.quality;

  if (false) { var parsedSrc, missingValues; }

  return "".concat(root, "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}

/***/ }),

/***/ "eLLw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AMOUNT */
/* unused harmony export APPROVAL_STATUSES */
/* unused harmony export STATUS_INCOMPLETE */
/* unused harmony export STATUS_COMPLETE */
/* unused harmony export GOAL_STATUSES */
/* unused harmony export PRODUCT_TYPES */
/* unused harmony export INTERVALS */
/* unused harmony export FORMAT_TYPES */
/* unused harmony export QUARTER_TYPES */
/* unused harmony export INVENTORY_TYPES */
/* unused harmony export INVENTORY_VALUES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BUTTON_HOVER_COLORS; });
/* unused harmony export BUTTON_NO_HOVER_COLORS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ICON_PROPS; });
/* unused harmony export BORDER_STYLE */
/* unused harmony export CONTRAST_BG */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ICON_BUTTON_CLASSES; });
/* unused harmony export AVATAR_PROPS */
/* unused harmony export TAP_TARGET */
/* unused harmony export ACCEPT_TABS */
/* unused harmony export MAKE_TABS */
/* unused harmony export NOMINATE_TABS_CONFIG */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUTO_ATTRS; });
/* unused harmony export INFO_MODAL_ICON */
/* unused harmony export SUGGESTIONABLE_ID */
/* unused harmony export SUGGESTION_KEYS */
/* harmony import */ var _utils_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("oCA+");

var AMOUNT = "amount";
var APPROVAL_STATUSES = ["pending", "review", "feedback", "approved", "denied", "suspended"];
var STATUS_INCOMPLETE = "incomplete";
var STATUS_COMPLETE = "complete";
var GOAL_STATUSES = [STATUS_INCOMPLETE, STATUS_COMPLETE];
var PRODUCT_TYPES = ["course", "open_source", "conference", "training", "workshop", "book", "certificate", "course", "tutorial", "mentorship", "retreat", // Additional
"blog", "service"];
var INTERVALS = ["", "hour", "day", "week", "month", "year"];
var FORMAT_TYPES = ["online", "live", "mixed"];
var QUARTER_TYPES = ["winter", "summer", "spring", "fall"];
var INVENTORY_TYPES = ["bucket"];
var INVENTORY_VALUES = ["limited"];
var BUTTON_HOVER_COLORS = {
  hover: "#555555",
  active: "#555555",
  activeHover: "#555555",
  inactive: "#949494"
};
var BUTTON_NO_HOVER_COLORS = {
  hover: "#949494",
  inactive: "#949494"
};
var ICON_PROPS = {
  size: 20,
  color: "#555555"
};
var BORDER_STYLE = {
  borderWidth: "0.0625rem"
};
var CONTRAST_BG = {
  backgroundColor: "#FAFAFA"
};
var ICON_BUTTON_CLASSES = {
  button: "pa0 ma0 bg-transparent pointer bn items-center flex"
};
var AVATAR_PROPS = {
  dimensions: {
    width: 50,
    height: 50
  }
};
var TAP_TARGET = {
  height: 40,
  width: 40
};
var ACCEPT_TABS = {
  label: "accept",
  children: []
};
var MAKE_TABS = {
  label: "make",
  children: [{
    label: "email"
  } // {
  //   label: 'slack'
  // },
  // {
  //   label: 'google'
  // }
  ]
};
var NOMINATE_TABS_CONFIG = [ACCEPT_TABS, MAKE_TABS];
var AUTO_ATTRS = {
  autoCapitalize: "none",
  autoComplete: "off",
  autoCorrect: "off",
  spellCheck: "false"
};
var INFO_MODAL_ICON = {
  iconType: "info",
  iconProps: {
    size: 26
  },
  colors: {
    hover: _utils_styles__WEBPACK_IMPORTED_MODULE_0__[/* COLORS */ "a"].blue,
    active: _utils_styles__WEBPACK_IMPORTED_MODULE_0__[/* COLORS */ "a"].blue,
    inactive: _utils_styles__WEBPACK_IMPORTED_MODULE_0__[/* COLORS */ "a"].blue
  }
};
var SUGGESTIONABLE_ID = "suggestionable_id";
var SUGGESTION_KEYS = ["id", "title", "description", "suggestionable_type", SUGGESTIONABLE_ID, "department_level_id", "organization_id", "tasks"];

/***/ }),

/***/ "foSv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _getPrototypeOf; });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ "gH8l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PADDER_SMALL */
/* unused harmony export PADDER_VISIBLE */
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rePB");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);


var _THEME_CLASSES;

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;

var PADDER_SMALL = "small";
var PADDER_VISIBLE = "visible";
var THEME_CLASSES = (_THEME_CLASSES = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_THEME_CLASSES, PADDER_VISIBLE, "dib h5-5 w-100"), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_THEME_CLASSES, PADDER_SMALL, "dib dn-ns h5-5 w-100"), _THEME_CLASSES);

var Padder = function Padder(_ref) {
  var theme = _ref.theme,
      customClasses = _ref.customClasses;
  return __jsx("div", {
    className: THEME_CLASSES[theme] || customClasses
  });
};

Padder.defaultProps = {
  customClasses: THEME_CLASSES.small
};
/* harmony default export */ __webpack_exports__["a"] = (Padder);

/***/ }),

/***/ "itsj":
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),

/***/ "jeLo":
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__("juv8"),
    keysIn = __webpack_require__("mTTR");

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),

/***/ "md7G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ _possibleConstructorReturn; });

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("JX7q");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js


function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return Object(assertThisInitialized["a" /* default */])(self);
}

/***/ }),

/***/ "qhYS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IconButton; });
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1OyB");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("vuIU");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("Ji7U");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("md7G");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("foSv");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lodash_assign__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("3OWR");
/* harmony import */ var lodash_assign__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_assign__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _LoadingSpinner__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("a/D+");
/* harmony import */ var _Form_fields_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("eLLw");
/* harmony import */ var _utils_constants_ui__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("IWZK");
/* harmony import */ var react_icons_io__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("IdFE");





var __jsx = react__WEBPACK_IMPORTED_MODULE_5___default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }








var ICONS = {
  up: react_icons_io__WEBPACK_IMPORTED_MODULE_11__[/* IoIosArrowUp */ "d"],
  down: react_icons_io__WEBPACK_IMPORTED_MODULE_11__[/* IoIosArrowDown */ "b"],
  closed: react_icons_io__WEBPACK_IMPORTED_MODULE_11__[/* IoIosArrowDown */ "b"],
  right: react_icons_io__WEBPACK_IMPORTED_MODULE_11__[/* IoIosArrowForward */ "c"],
  add: react_icons_io__WEBPACK_IMPORTED_MODULE_11__[/* IoIosAdd */ "a"],
  remove: react_icons_io__WEBPACK_IMPORTED_MODULE_11__[/* IoIosRemove */ "o"],
  edit: react_icons_io__WEBPACK_IMPORTED_MODULE_11__[/* IoMdCreate */ "x"],
  cancel: react_icons_io__WEBPACK_IMPORTED_MODULE_11__[/* IoMdClose */ "w"],
  close: react_icons_io__WEBPACK_IMPORTED_MODULE_11__[/* IoMdClose */ "w"],
  trash: react_icons_io__WEBPACK_IMPORTED_MODULE_11__[/* IoIosRemoveCircleOutline */ "p"],
  refresh: react_icons_io__WEBPACK_IMPORTED_MODULE_11__[/* IoIosRefresh */ "n"],
  more: react_icons_io__WEBPACK_IMPORTED_MODULE_11__[/* IoIosMore */ "l"],
  open: react_icons_io__WEBPACK_IMPORTED_MODULE_11__[/* IoMdOpen */ "z"],
  save: react_icons_io__WEBPACK_IMPORTED_MODULE_11__[/* IoIosSave */ "q"],
  star: react_icons_io__WEBPACK_IMPORTED_MODULE_11__[/* IoIosStar */ "s"],
  bookmark: react_icons_io__WEBPACK_IMPORTED_MODULE_11__[/* IoIosBookmark */ "e"],
  tick: react_icons_io__WEBPACK_IMPORTED_MODULE_11__[/* IoMdCheckmark */ "u"],
  checkmark: react_icons_io__WEBPACK_IMPORTED_MODULE_11__[/* IoMdCheckmarkCircle */ "v"],
  suggestion: react_icons_io__WEBPACK_IMPORTED_MODULE_11__[/* IoIosList */ "j"],
  magic: react_icons_io__WEBPACK_IMPORTED_MODULE_11__[/* IoIosColorWand */ "h"],
  list: react_icons_io__WEBPACK_IMPORTED_MODULE_11__[/* IoMdList */ "y"],
  info: react_icons_io__WEBPACK_IMPORTED_MODULE_11__[/* IoIosInformationCircleOutline */ "i"],
  move: react_icons_io__WEBPACK_IMPORTED_MODULE_11__[/* IoIosMove */ "m"]
};

var IconButton = /*#__PURE__*/function (_Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(IconButton, _Component);

  var _super = _createSuper(IconButton);

  function IconButton() {
    var _this;

    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(this, IconButton);

    _this = _super.call(this);
    _this.state = {
      hover: false
    };
    return _this;
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(IconButton, [{
    key: "hover",
    value: function hover(_hover) {
      var _this2 = this;

      return function () {
        _this2.setState({
          hover: _hover
        });
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          disabled = _this$props.disabled,
          active = _this$props.active,
          onClick = _this$props.onClick,
          iconType = _this$props.iconType,
          iconProps = _this$props.iconProps,
          colors = _this$props.colors,
          customClasses = _this$props.customClasses,
          customStyles = _this$props.customStyles,
          loading = _this$props.loading;
      var IconComp = ICONS[iconType];
      if (!IconComp) return null;
      var hover = this.state.hover;
      var icProps = lodash_assign__WEBPACK_IMPORTED_MODULE_6___default()({}, _Form_fields_constants__WEBPACK_IMPORTED_MODULE_9__[/* ICON_PROPS */ "d"], iconProps);
      var classes = lodash_assign__WEBPACK_IMPORTED_MODULE_6___default()({}, _Form_fields_constants__WEBPACK_IMPORTED_MODULE_9__[/* ICON_BUTTON_CLASSES */ "c"], customClasses);
      var baseStyle = disabled ? {
        cursor: "not-allowed"
      } : {};
      var styles = lodash_assign__WEBPACK_IMPORTED_MODULE_6___default()({
        outline: "none"
      }, baseStyle, customStyles);
      var buttonProps = {
        type: _utils_constants_ui__WEBPACK_IMPORTED_MODULE_10__[/* BUTTON_TAGS */ "b"].BUTTON,
        disabled: disabled,
        className: classnames__WEBPACK_IMPORTED_MODULE_7___default()("".concat(classes.button, " ").concat(_utils_constants_ui__WEBPACK_IMPORTED_MODULE_10__[/* TA_MAN */ "o"]), {
          "o-30": disabled
        }),
        style: styles
      };

      if (Boolean(onClick) && !loading && !disabled) {
        buttonProps.onClick = onClick;
      }

      icProps.color = colors.inactive;

      if (active) {
        if (hover) {
          icProps.color = colors.activeHover;
        } else {
          icProps.color = colors.active;
        }
      } else if (hover) {
        icProps.color = colors.hover;
      }

      var hoverMgmtProps = {
        onMouseEnter: this.hover(true),
        onMouseLeave: this.hover(false)
      };
      return __jsx("div", hoverMgmtProps, loading ? __jsx(_LoadingSpinner__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"], {
        customClasses: {
          ring: "blue"
        }
      }) : __jsx("button", buttonProps, __jsx(IconComp, icProps)));
    }
  }]);

  return IconButton;
}(react__WEBPACK_IMPORTED_MODULE_5__["Component"]);


IconButton.defaultProps = {
  disabled: false,
  active: false,
  colors: _Form_fields_constants__WEBPACK_IMPORTED_MODULE_9__[/* BUTTON_HOVER_COLORS */ "b"]
};

/***/ }),

/***/ "sEfC":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("GoyQ"),
    now = __webpack_require__("QIyF"),
    toNumber = __webpack_require__("tLB3");

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ "t2Dn":
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__("hypo"),
    eq = __webpack_require__("ljhN");

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),

/***/ "vNVm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__("J4zp");

var _interopRequireDefault = __webpack_require__("TqRt");

exports.__esModule = true;
exports.useIntersection = useIntersection;

var _react = __webpack_require__("q1tI");

var _requestIdleCallback = _interopRequireDefault(__webpack_require__("0G5g"));

var hasIntersectionObserver = typeof IntersectionObserver !== 'undefined';

function useIntersection(_ref) {
  var rootMargin = _ref.rootMargin,
      disabled = _ref.disabled;
  var isDisabled = disabled || !hasIntersectionObserver;
  var unobserve = (0, _react.useRef)();

  var _ref2 = (0, _react.useState)(false),
      _ref3 = _slicedToArray(_ref2, 2),
      visible = _ref3[0],
      setVisible = _ref3[1];

  var setRef = (0, _react.useCallback)(function (el) {
    if (unobserve.current) {
      unobserve.current();
      unobserve.current = undefined;
    }

    if (isDisabled || visible) return;

    if (el && el.tagName) {
      unobserve.current = observe(el, function (isVisible) {
        return isVisible && setVisible(isVisible);
      }, {
        rootMargin: rootMargin
      });
    }
  }, [isDisabled, rootMargin, visible]);
  (0, _react.useEffect)(function () {
    if (!hasIntersectionObserver) {
      if (!visible) (0, _requestIdleCallback["default"])(function () {
        return setVisible(true);
      });
    }
  }, [visible]);
  return [setRef, visible];
}

function observe(element, callback, options) {
  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements;

  elements.set(element, callback);
  observer.observe(element);
  return function unobserve() {
    observer.unobserve(element); // Destroy observer when there's nothing left to watch:

    if (elements.size === 0) {
      observer.disconnect();
      observers["delete"](id);
    }
  };
}

var observers = new Map();

function createObserver(options) {
  var id = options.rootMargin || '';
  var instance = observers.get(id);

  if (instance) {
    return instance;
  }

  var elements = new Map();
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var callback = elements.get(entry.target);
      var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;

      if (callback && isVisible) {
        callback(isVisible);
      }
    });
  }, options);
  observers.set(id, instance = {
    id: id,
    observer: observer,
    elements: elements
  });
  return instance;
}

/***/ }),

/***/ "vlbB":
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor,
    nativeRandom = Math.random;

/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */
function baseRandom(lower, upper) {
  return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
}

module.exports = baseRandom;


/***/ }),

/***/ "vuIU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _createClass; });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/***/ }),

/***/ "x9nw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getWindow */
/* unused harmony export isSm */
/* unused harmony export isMobile */
/* unused harmony export isPhone */
/* unused harmony export formFactorAction */
/* unused harmony export gridCellWidth */
/* unused harmony export scrollTop */
/* unused harmony export scrollTo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isServer; });
/* unused harmony export fixBody */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return unfixBody; });
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("mwIZ");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("IWZK");


var FIXED_CLASS = "fixed";
var getWindow = function getWindow(path) {
  if (true) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(window, path);
  }

  return {};
};
var isSm = function isSm() {
  return getWindow("innerWidth") <= _constants_ui__WEBPACK_IMPORTED_MODULE_1__[/* PHONE */ "j"];
};
var isMobile = function isMobile() {
  return getWindow("innerWidth") < _constants_ui__WEBPACK_IMPORTED_MODULE_1__[/* DESKTOP */ "e"];
};
var isPhone = function isPhone() {
  return getWindow("innerWidth") < _constants_ui__WEBPACK_IMPORTED_MODULE_1__[/* MOBILE */ "g"];
};
var formFactorAction = function formFactorAction() {
  return getWindow("innerWidth") <= 480 ? "Tap" : "Click";
};
/**
 * gridCellWidth
 * - Calculate the width of cells within product feeds
 * @param {bool} isMobile
 * @param {bool} isPhone
 * @param {number} columns
 */

var gridCellWidth = function gridCellWidth(isMobile, isPhone) {
  var columns = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 4;
  return isMobile ? isPhone ? "calc(100%)" : "calc(33% - 0.5rem)" : "calc(".concat(100 / columns, "% - 0.5rem)");
};
var scrollTop = function scrollTop(node) {
  if (node && node.scrollIntoView) {
    node.scrollIntoView();
  }
};
var scrollTo = function scrollTo() {
  var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
   true && window.scrollTo(x, y);
};
var isServer = function isServer() {
  return false;
};
var fixBody = function fixBody() {
  return document.getElementsByTagName("body")[0].classList.add(FIXED_CLASS);
};
var unfixBody = function unfixBody() {
  return document.getElementsByTagName("body")[0].classList.remove(FIXED_CLASS);
};

/***/ })

}]);